/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.49.0-dev-20240426(707338797bebe978449ded37c419c5daf5ad63ec)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/editor/editor.main.nls.es", {
	"vs/base/browser/ui/actionbar/actionViewItems": [
		"{0} ({1})",
	],
	"vs/base/browser/ui/findinput/findInput": [
		"entrada",
	],
	"vs/base/browser/ui/findinput/findInputToggles": [
		"Coincidir mayúsculas y minúsculas",
		"Solo palabras completas",
		"Usar expresión regular",
	],
	"vs/base/browser/ui/findinput/replaceInput": [
		"entrada",
		"Conservar may/min",
	],
	"vs/base/browser/ui/hover/hoverWidget": [
		"Inspeccione esto en la vista accesible con {0}.",
		"Inspeccione esto en la vista accesible mediante el comando Abrir vista accesible, que actualmente no se puede desencadenar mediante el enlace de teclado.",
	],
	"vs/base/browser/ui/inputbox/inputBox": [
		"Error: {0}",
		"Advertencia: {0}",
		"Información: {0}",
		" o {0} para el historial",
		" ({0} para el historial)",
		"Entrada borrada",
	],
	"vs/base/browser/ui/keybindingLabel/keybindingLabel": [
		"Sin enlazar",
	],
	"vs/base/browser/ui/selectBox/selectBoxCustom": [
		"Seleccionar cuadro",
	],
	"vs/base/browser/ui/toolbar/toolbar": [
		"Más Acciones...",
	],
	"vs/base/browser/ui/tree/abstractTree": [
		"Filtrar",
		"Coincidencia aproximada",
		"Escriba texto para filtrar",
		"Escriba texto para buscar",
		"Escriba texto para buscar",
		"Cerrar",
		"No se encontraron elementos.",
	],
	"vs/base/common/actions": [
		"(vacío)",
	],
	"vs/base/common/errorMessage": [
		"{0}: {1}",
		"Error del sistema ({0})",
		"Se ha producido un error desconocido. Consulte el registro para obtener más detalles.",
		"Se ha producido un error desconocido. Consulte el registro para obtener más detalles.",
		"{0} ({1} errores en total)",
		"Se ha producido un error desconocido. Consulte el registro para obtener más detalles.",
	],
	"vs/base/common/keybindingLabels": [
		"Ctrl",
		"Mayús",
		"Alt",
		"Windows",
		"Ctrl",
		"Mayús",
		"Alt",
		"Super",
		"Control",
		"Mayús",
		"Opción",
		"Comando",
		"Control",
		"Mayús",
		"Alt",
		"Windows",
		"Control",
		"Mayús",
		"Alt",
		"Super",
	],
	"vs/base/common/platform": [
		"_",
	],
	"vs/editor/browser/controller/textAreaHandler": [
		"editor",
		"No se puede acceder al editor en este momento.",
		"{0} Para habilitar el modo optimizado para lectores de pantalla, use {1}",
		"{0} Para habilitar el modo optimizado para lector de pantalla, abra la selección rápida con {1} y ejecute el comando Alternar modo de accesibilidad del lector de pantalla, que actualmente no se puede desencadenar mediante el teclado.",
		"{0} Para asignar un enlace de teclado para el comando Alternar modo de accesibilidad del lector de pantalla, acceda al editor de enlaces de teclado con {1} y ejecútelo.",
	],
	"vs/editor/browser/coreCommands": [
		"Anclar al final incluso cuando se vayan a líneas más largas",
		"Anclar al final incluso cuando se vayan a líneas más largas",
		"Cursores secundarios quitados",
	],
	"vs/editor/browser/editorExtensions": [
		"&&Deshacer",
		"Deshacer",
		"&&Rehacer",
		"Rehacer",
		"&&Seleccionar todo",
		"Seleccionar todo",
	],
	"vs/editor/browser/services/hoverService/hoverWidget": [
		"Hold {0} key to mouse over",
	],
	"vs/editor/browser/services/hoverService/updatableHoverWidget": [
		"Loading...",
	],
	"vs/editor/browser/widget/codeEditor/codeEditorWidget": [
		"The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.",
		"Increase Multi Cursor Limit",
	],
	"vs/editor/browser/widget/diffEditor/commands": [
		"Toggle Collapse Unchanged Regions",
		"Toggle Show Moved Code Blocks",
		"Toggle Use Inline View When Space Is Limited",
		"Diff Editor",
		"Switch Side",
		"Exit Compare Move",
		"Collapse All Unchanged Regions",
		"Show All Unchanged Regions",
		"Revert",
		"Accessible Diff Viewer",
		"Go to Next Difference",
		"Go to Previous Difference",
	],
	"vs/editor/browser/widget/diffEditor/components/accessibleDiffViewer": [
		"Icono de \"Insertar\" en el visor de diferencias accesible.",
		"Icono de \"Quitar\" en el visor de diferencias accesible.",
		"Icono de \"Cerrar\" en el visor de diferencias accesible.",
		"Cerrar",
		"Visor de diferencias accesible. Utilice la flecha hacia arriba y hacia abajo para navegar.",
		"no se han cambiado líneas",
		"1 línea cambiada",
		"{0} líneas cambiadas",
		"Diferencia {0} de {1}: línea original {2}, {3}, línea modificada {4}, {5}",
		"vacío",
		"{0} línea sin cambios {1}",
		"{0} línea original {1} línea modificada {2}",
		"+ {0} línea modificada {1}",
		"- {0} línea original {1}",
	],
	"vs/editor/browser/widget/diffEditor/components/diffEditorEditors": [
		" use {0} para abrir la ayuda de accesibilidad.",
	],
	"vs/editor/browser/widget/diffEditor/components/diffEditorViewZones/inlineDiffDeletedCodeMargin": [
		"Copiar líneas eliminadas",
		"Copiar línea eliminada",
		"Copiar líneas cambiadas",
		"Copiar línea cambiada",
		"Copiar la línea eliminada ({0})",
		"Copiar línea cambiada ({0})",
		"Revertir este cambio",
	],
	"vs/editor/browser/widget/diffEditor/diffEditor.contribution": [
		"Uso de la vista insertada cuando el espacio es limitado",
		"Mostrar bloques de código movidos",
		"Revert Block",
		"Revert Selection",
		"Abrir visor de diferencias accesibles",
	],
	"vs/editor/browser/widget/diffEditor/features/hideUnchangedRegionsFeature": [
		"Plegar la región sin cambios",
		"Haga clic o arrastre para mostrar más arriba",
		"Mostrar región sin cambios",
		"Hacer clic o arrastrar para mostrar más abajo",
		"{0} líneas ocultas",
		"Doble clic para desplegar",
	],
	"vs/editor/browser/widget/diffEditor/features/movedBlocksLinesFeature": [
		"Código movido con cambios en la línea {0}-{1}",
		"Código movido con cambios de la línea {0}-{1}",
		"Código movido a la línea {0}-{1}",
		"Código movido de la línea {0}-{1}",
	],
	"vs/editor/browser/widget/diffEditor/features/revertButtonsFeature": [
		"Revertir los cambios seleccionados",
		"Revertir el cambio",
	],
	"vs/editor/browser/widget/diffEditor/registrations.contribution": [
		"Color del borde del texto que se movió en el editor de diferencias.",
		"Color del borde de texto activo que se movió en el editor de diferencias.",
		"Color de la sombra paralela en torno a los widgets de región sin cambios.",
		"Decoración de línea para las inserciones en el editor de diferencias.",
		"Decoración de línea para las eliminaciones en el editor de diferencias.",
	],
	"vs/editor/browser/widget/multiDiffEditor/colors": [
		"The background color of the diff editor\'s header",
		"The background color of the multi file diff editor",
		"The border color of the multi file diff editor",
	],
	"vs/editor/common/config/editorConfigurationSchema": [
		"Editor",
		"El número de espacios a los que equivale una tabulación. Este valor se invalida en función del contenido del archivo cuando {0} está activado.",
		"Número de espacios usados para la sangría o \"tabSize\" para usar el valor de \"#editor.tabSize#\". Esta configuración se invalida en función del contenido del archivo cuando \"#editor.detectIndentation#\" está activado.",
		"Insertar espacios al presionar \"TAB\". Este valor se invalida en función del contenido del archivo cuando {0} está activado.",
		"Controla si {0} y {1} se detectan automáticamente al abrir un archivo en función del contenido de este.",
		"Quitar el espacio en blanco final autoinsertado.",
		"Manejo especial para archivos grandes para desactivar ciertas funciones de memoria intensiva.",
		"Desactivar sugerencias basadas en Word.",
		"Sugerir palabras solo del documento activo.",
		"Sugerir palabras de todos los documentos abiertos del mismo idioma.",
		"Sugerir palabras de todos los documentos abiertos.",
		"Controla si las finalizaciones se deben calcular en función de las palabras del documento y desde qué documentos se calculan.",
		"El resaltado semántico está habilitado para todos los temas de color.",
		"El resaltado semántico está deshabilitado para todos los temas de color.",
		"El resaltado semántico está configurado con el valor \"semanticHighlighting\" del tema de color actual.",
		"Controla si se muestra semanticHighlighting para los idiomas que lo admiten.",
		"Mantiene abiertos los editores interactivos, incluso al hacer doble clic en su contenido o presionar \"Escape\".",
		"Las lineas por encima de esta longitud no se tokenizarán por razones de rendimiento.",
		"Controla si la tokenización debe producirse de forma asincrónica en un rol de trabajo.",
		"Controla si se debe registrar la tokenización asincrónica. Solo para depuración.",
		"Controla si se debe comprobar la tokenización asincrónica con la tokenización en segundo plano heredada. Puede ralentizar la tokenización. Solo para depuración.",
		"Define los corchetes que aumentan o reducen la sangría.",
		"Secuencia de cadena o corchete de apertura.",
		"Secuencia de cadena o corchete de cierre.",
		"Define los pares de corchetes coloreados por su nivel de anidamiento si está habilitada la coloración de par de corchetes.",
		"Secuencia de cadena o corchete de apertura.",
		"Secuencia de cadena o corchete de cierre.",
		"Tiempo de espera en milisegundos después del cual se cancela el cálculo de diferencias. Utilice 0 para no usar tiempo de espera.",
		"Tamaño máximo de archivo en MB para el que calcular diferencias. Use 0 para no limitar.",
		"Controla si el editor de diferencias muestra las diferencias en paralelo o alineadas.",
		"Si el ancho del editor de diferencias es menor que este valor, se usa la vista insertada.",
		"Si está habilitada y el ancho del editor es demasiado pequeño, se usa la vista en línea.",
		"Cuando está habilitado, el editor de diferencias muestra flechas en su margen de glifo para revertir los cambios.",
		"When enabled, the diff editor shows a special gutter for revert and stage actions.",
		"Cuando está habilitado, el editor de diferencias omite los cambios en los espacios en blanco iniciales o finales.",
		"Controla si el editor de diferencias muestra los indicadores +/- para los cambios agregados o quitados.",
		"Controla si el editor muestra CodeLens.",
		"Las líneas no se ajustarán nunca.",
		"Las líneas se ajustarán en el ancho de la ventanilla.",
		"Las líneas se ajustarán en función de la configuración de {0}.",
		"Usa el algoritmo de diferenciación heredado.",
		"Usa el algoritmo de diferenciación avanzada.",
		"Controla si el editor de diferencias muestra las regiones sin cambios.",
		"Controla cuántas líneas se usan para las regiones sin cambios.",
		"Controla cuántas líneas se usan como mínimo para las regiones sin cambios.",
		"Controla cuántas líneas se usan como contexto al comparar regiones sin cambios.",
		"Controlar si el editor de diferencias debe mostrar los movimientos de código detectados.",
		"Controla si el editor de diferencias muestra decoraciones vacías para ver dónde se insertan o eliminan los caracteres.",
	],
	"vs/editor/common/config/editorOptions": [
		"Usar las API de la plataforma para detectar cuándo se conecta un lector de pantalla.",
		"Optimizar para usar con un lector de pantalla.",
		"Supongamos que no hay un lector de pantalla conectado.",
		"Controla si la interfaz de usuario debe ejecutarse en un modo en el que esté optimizada para lectores de pantalla.",
		"Controla si se inserta un carácter de espacio al comentar.",
		"Controla si las líneas vacías deben ignorarse con la opción de alternar, agregar o quitar acciones para los comentarios de línea.",
		"Controla si al copiar sin selección se copia la línea actual.",
		"Controla si el cursor debe saltar para buscar coincidencias mientras se escribe.",
		"Nunca inicializar la cadena de búsqueda desde la selección del editor.",
		"Siempre inicializar la cadena de búsqueda desde la selección del editor, incluida la palabra en la posición del cursor.",
		"Solo inicializar la cadena de búsqueda desde la selección del editor.",
		"Controla si la cadena de búsqueda del widget de búsqueda se inicializa desde la selección del editor.",
		"No activar nunca Buscar en selección automáticamente (predeterminado).",
		"Activar siempre Buscar en selección automáticamente.",
		"Activar Buscar en la selección automáticamente cuando se seleccionen varias líneas de contenido.",
		"Controla la condición para activar la búsqueda en la selección de forma automática.",
		"Controla si el widget de búsqueda debe leer o modificar el Portapapeles de búsqueda compartido en macOS.",
		"Controla si Encontrar widget debe agregar más líneas en la parte superior del editor. Si es true, puede desplazarse más allá de la primera línea cuando Encontrar widget está visible.",
		"Controla si la búsqueda se reinicia automáticamente desde el principio (o el final) cuando no se encuentran más coincidencias.",
		"Habilita o deshabilita las ligaduras tipográficas (características de fuente \"calt\" y \"liga\"). Cámbielo a una cadena para el control específico de la propiedad de CSS \"font-feature-settings\".",
		"Propiedad de CSS \"font-feature-settings\" explícita. En su lugar, puede pasarse un valor booleano si solo es necesario activar o desactivar las ligaduras.",
		"Configura las ligaduras tipográficas o las características de fuente. Puede ser un valor booleano para habilitar o deshabilitar las ligaduras o bien una cadena para el valor de la propiedad \"font-feature-settings\" de CSS.",
		"Habilita o deshabilita la traducción del grosor de font-weight a font-variation-settings. Cambie esto a una cadena para el control específico de la propiedad CSS \'font-variation-settings\'.",
		"Propiedad CSS explícita \'font-variation-settings\'. En su lugar, se puede pasar un valor booleano si solo es necesario traducir font-weight a font-variation-settings.",
		"Configura variaciones de fuente. Puede ser un booleano para habilitar o deshabilitar la traducción de font-weight a font-variation-settings o una cadena para el valor de la propiedad CSS \'font-variation-settings\'.",
		"Controla el tamaño de fuente en píxeles.",
		"Solo se permiten las palabras clave \"normal\" y \"negrita\" o los números entre 1 y 1000.",
		"Controla el grosor de la fuente. Acepta las palabras clave \"normal\" y \"negrita\" o los números entre 1 y 1000.",
		"Mostrar vista de inspección de los resultados (predeterminado)",
		"Ir al resultado principal y mostrar una vista de inspección",
		"Vaya al resultado principal y habilite la navegación sin peek para otros",
		"Esta configuración está en desuso. Use configuraciones separadas como \"editor.editor.gotoLocation.multipleDefinitions\" o \"editor.editor.gotoLocation.multipleImplementations\" en su lugar.",
		"Controla el comportamiento del comando \"Ir a definición\" cuando existen varias ubicaciones de destino.",
		"Controla el comportamiento del comando \"Ir a definición de tipo\" cuando existen varias ubicaciones de destino.",
		"Controla el comportamiento del comando \"Ir a declaración\" cuando existen varias ubicaciones de destino.",
		"Controla el comportamiento del comando \"Ir a implementaciones\" cuando existen varias ubicaciones de destino.",
		"Controla el comportamiento del comando \"Ir a referencias\" cuando existen varias ubicaciones de destino.",
		"Identificador de comando alternativo que se ejecuta cuando el resultado de \"Ir a definición\" es la ubicación actual.",
		"Id. de comando alternativo que se está ejecutando cuando el resultado de \"Ir a definición de tipo\" es la ubicación actual.",
		"Id. de comando alternativo que se está ejecutando cuando el resultado de \"Ir a declaración\" es la ubicación actual.",
		"Id. de comando alternativo que se está ejecutando cuando el resultado de \"Ir a implementación\" es la ubicación actual.",
		"Identificador de comando alternativo que se ejecuta cuando el resultado de \"Ir a referencia\" es la ubicación actual.",
		"Controla si se muestra la información al mantener el puntero sobre un elemento.",
		"Controla el retardo en milisegundos después del cual se muestra la información al mantener el puntero sobre un elemento.",
		"Controla si la información que aparece al mantener el puntero sobre un elemento permanece visible al mover el mouse sobre este.",
		"Controla el retraso en milisegundos después del cual se oculta el desplazamiento. Requiere que se habilite `editor.hover.sticky`.",
		"Preferir mostrar los desplazamientos por encima de la línea, si hay espacio.",
		"Se supone que todos los caracteres son del mismo ancho. Este es un algoritmo rápido que funciona correctamente para fuentes monoespaciales y ciertos scripts (como caracteres latinos) donde los glifos tienen el mismo ancho.",
		"Delega el cálculo de puntos de ajuste en el explorador. Es un algoritmo lento, que podría causar bloqueos para archivos grandes, pero funciona correctamente en todos los casos.",
		"Controla el algoritmo que calcula los puntos de ajuste. Tenga en cuenta que, en el modo de accesibilidad, se usará el modo avanzado para obtener la mejor experiencia.",
		"Deshabilite el menú de acción de código.",
		"Muestra el menú de acción del código cuando el cursor está en líneas con código.",
		"Muestra el menú de acción de código cuando el cursor está en líneas con código o en líneas vacías.",
		"Habilita la bombilla de acción de código en el editor.",
		"Muestra los ámbitos actuales anidados durante el desplazamiento en la parte superior del editor.",
		"Define el número máximo de líneas rápidas que se mostrarán.",
		"Define el modelo que se va a usar para determinar qué líneas se van a pegar. Si el modelo de esquema no existe, recurrirá al modelo del proveedor de plegado que recurre al modelo de sangría. Este orden se respeta en los tres casos.",
		"Habilite el desplazamiento de desplazamiento rápido con la barra de desplazamiento horizontal del editor.",
		"Habilita las sugerencias de incrustación en el editor.",
		"Las sugerencias de incrustación están habilitadas",
		"Las sugerencias de incrustación se muestran de forma predeterminada y se ocultan cuando se mantiene presionado {0}",
		"Las sugerencias de incrustación están ocultas de forma predeterminada y se muestran al mantener presionado {0}",
		"Las sugerencias de incrustación están deshabilitadas",
		"Controla el tamaño de fuente de las sugerencias de incrustación en el editor. Como valor predeterminado, se usa {0} cuando el valor configurado es menor que {1} o mayor que el tamaño de fuente del editor.",
		"Controla la familia de fuentes de sugerencias de incrustación en el editor. Cuando se establece en vacío, se usa el {0}.",
		"Habilita el relleno alrededor de las sugerencias de incrustación en el editor.",
		"Controla el alto de línea. \r\n - Use 0 para calcular automáticamente el alto de línea a partir del tamaño de la fuente.\r\n - Los valores entre 0 y 8 se usarán como multiplicador con el tamaño de fuente.\r\n - Los valores mayores o igual que 8 se usarán como valores efectivos.",
		"Controla si se muestra el minimapa.",
		"Controla si el minimapa se oculta automáticamente.",
		"El minimapa tiene el mismo tamaño que el contenido del editor (y podría desplazarse).",
		"El minimapa se estirará o reducirá según sea necesario para ocupar la altura del editor (sin desplazamiento).",
		"El minimapa se reducirá según sea necesario para no ser nunca más grande que el editor (sin desplazamiento).",
		"Controla el tamaño del minimapa.",
		"Controla en qué lado se muestra el minimapa.",
		"Controla cuándo se muestra el control deslizante del minimapa.",
		"Escala del contenido dibujado en el minimapa: 1, 2 o 3.",
		"Represente los caracteres reales en una línea, por oposición a los bloques de color.",
		"Limite el ancho del minimapa para representar como mucho un número de columnas determinado.",
		"Controls whether named regions are shown as section headers in the minimap.",
		"Controls whether MARK: comments are shown as section headers in the minimap.",
		"Controls the font size of section headers in the minimap.",
		"Controla la cantidad de espacio entre el borde superior del editor y la primera línea.",
		"Controla el espacio entre el borde inferior del editor y la última línea.",
		"Habilita un elemento emergente que muestra documentación de los parámetros e información de los tipos mientras escribe.",
		"Controla si el menú de sugerencias de parámetros se cicla o se cierra al llegar al final de la lista.",
		"Las sugerencias rápidas se muestran dentro del widget de sugerencias",
		"Las sugerencias rápidas se muestran como texto fantasma",
		"Las sugerencias rápidas están deshabilitadas",
		"Habilita sugerencias rápidas en las cadenas.",
		"Habilita sugerencias rápidas en los comentarios.",
		"Habilita sugerencias rápidas fuera de las cadenas y los comentarios.",
		"Controla si las sugerencias deben mostrarse automáticamente al escribir. Puede controlarse para la escritura en comentarios, cadenas y otro código. Las sugerencias rápidas pueden configurarse para mostrarse como texto fantasma o con el widget de sugerencias. Tenga también en cuenta la configuración \'{0}\' que controla si las sugerencias son desencadenadas por caracteres especiales.",
		"Los números de línea no se muestran.",
		"Los números de línea se muestran como un número absoluto.",
		"Los números de línea se muestran como distancia en líneas a la posición del cursor.",
		"Los números de línea se muestran cada 10 líneas.",
		"Controla la visualización de los números de línea.",
		"Número de caracteres monoespaciales en los que se representará esta regla del editor.",
		"Color de esta regla del editor.",
		"Muestra reglas verticales después de un cierto número de caracteres monoespaciados. Usa múltiples valores para mostrar múltiples reglas. Si la matriz está vacía, no se muestran reglas.",
		"La barra de desplazamiento vertical estará visible solo cuando sea necesario.",
		"La barra de desplazamiento vertical estará siempre visible.",
		"La barra de desplazamiento vertical estará siempre oculta.",
		"Controla la visibilidad de la barra de desplazamiento vertical.",
		"La barra de desplazamiento horizontal estará visible solo cuando sea necesario.",
		"La barra de desplazamiento horizontal estará siempre visible.",
		"La barra de desplazamiento horizontal estará siempre oculta.",
		"Controla la visibilidad de la barra de desplazamiento horizontal.",
		"Ancho de la barra de desplazamiento vertical.",
		"Altura de la barra de desplazamiento horizontal.",
		"Controla si al hacer clic se desplaza por página o salta a la posición donde se hace clic.",
		"Cuando se establece, la barra de desplazamiento horizontal no aumentará el tamaño del contenido del editor.",
		"Controla si se resaltan todos los caracteres ASCII no básicos. Solo los caracteres entre U+0020 y U+007E, tabulación, avance de línea y retorno de carro se consideran ASCII básicos.",
		"Controla si se resaltan los caracteres que solo reservan espacio o que no tienen ancho.",
		"Controla si se resaltan caracteres que se pueden confundir con caracteres ASCII básicos, excepto los que son comunes en la configuración regional del usuario actual.",
		"Controla si los caracteres de los comentarios también deben estar sujetos al resaltado Unicode.",
		"Controla si los caracteres de las cadenas también deben estar sujetos al resaltado Unicode.",
		"Define los caracteres permitidos que no se resaltan.",
		"Los caracteres Unicode que son comunes en las configuraciones regionales permitidas no se resaltan.",
		"Controla si se deben mostrar automáticamente las sugerencias alineadas en el editor.",
		"Muestra la barra de herramientas de sugerencias insertadas cada vez que se muestra una sugerencia insertada.",
		"Muestra la barra de herramientas de sugerencias insertadas al mantener el puntero sobre una sugerencia insertada.",
		"No mostrar nunca la barra de herramientas de sugerencias insertadas.",
		"Controla cuándo mostrar la barra de herramientas de sugerencias insertadas.",
		"Controla cómo interactúan las sugerencias insertadas con el widget de sugerencias. Si se habilita, el widget de sugerencias no se muestra automáticamente cuando hay sugerencias insertadas disponibles.",
		"Controla la familia de fuentes de las sugerencias insertadas.",
		"Controla si se van a mostrar las ediciones insertadas en el editor.",
		"Muestra la barra de herramientas de edición insertada cada vez que se muestra una sugerencia insertada.",
		"Mostrar la barra de herramientas de edición insertada al pasar el ratón por encima de una sugerencia insertada.",
		"No mostrar nunca la barra de herramientas de edición insertada.",
		"Controla cuándo mostrar la barra de herramientas de edición insertada.",
		"Controla la familia de fuentes de la edición insertada.",
		"Controla si se colorea el fondo de las ediciones insertadas.",
		"Controla si está habilitada o no la coloración de pares de corchetes. Use {0} para invalidar los colores de resaltado de corchete.",
		"Controla si cada tipo de corchete tiene su propio grupo de colores independiente.",
		"Habilita guías de par de corchetes.",
		"Habilita guías de par de corchetes solo para el par de corchetes activo.",
		"Deshabilita las guías de par de corchetes.",
		"Controla si están habilitadas las guías de pares de corchetes.",
		"Habilita guías horizontales como adición a guías de par de corchetes verticales.",
		"Habilita guías horizontales solo para el par de corchetes activo.",
		"Deshabilita las guías de par de corchetes horizontales.",
		"Controla si están habilitadas las guías de pares de corchetes horizontales.",
		"Controla si el editor debe resaltar el par de corchetes activo.",
		"Controla si el editor debe representar guías de sangría.",
		"Resalta la guía de sangría activa.",
		"Resalta la guía de sangría activa incluso si se resaltan las guías de corchetes.",
		"No resalta la guía de sangría activa.",
		"Controla si el editor debe resaltar la guía de sangría activa.",
		"Inserte la sugerencia sin sobrescribir el texto a la derecha del cursor.",
		"Inserte la sugerencia y sobrescriba el texto a la derecha del cursor.",
		"Controla si las palabras se sobrescriben al aceptar la finalización. Tenga en cuenta que esto depende de las extensiones que participan en esta característica.",
		"Controla si el filtrado y la ordenación de sugerencias se tienen en cuenta para los errores ortográficos pequeños.",
		"Controla si la ordenación mejora las palabras que aparecen cerca del cursor.",
		"Controla si las selecciones de sugerencias recordadas se comparten entre múltiples áreas de trabajo y ventanas (necesita \"#editor.suggestSelection#\").",
		"Seleccione siempre una sugerencia cuando se desencadene IntelliSense automáticamente.",
		"Nunca seleccione una sugerencia cuando desencadene IntelliSense automáticamente.",
		"Seleccione una sugerencia solo cuando desencadene IntelliSense desde un carácter de desencadenador.",
		"Seleccione una sugerencia solo cuando desencadene IntelliSense mientras escribe.",
		"Controla si se selecciona una sugerencia cuando se muestra el widget. Tenga en cuenta que esto solo se aplica a las sugerencias desencadenadas automáticamente (`#editor.quickSuggestions#` y `#editor.suggestOnTriggerCharacters#`) y que siempre se selecciona una sugerencia cuando se invoca explícitamente, por ejemplo, a través de \'Ctrl+Espacio\'.",
		"Controla si un fragmento de código activo impide sugerencias rápidas.",
		"Controla si mostrar u ocultar iconos en sugerencias.",
		"Controla la visibilidad de la barra de estado en la parte inferior del widget de sugerencias.",
		"Controla si se puede obtener una vista previa del resultado de la sugerencia en el editor.",
		"Controla si los detalles de sugerencia se muestran incorporados con la etiqueta o solo en el widget de detalles.",
		"La configuración está en desuso. Ahora puede cambiarse el tamaño del widget de sugerencias.",
		"Esta configuración está en desuso. Use configuraciones separadas como \"editor.suggest.showKeyword\" o \"editor.suggest.showSnippets\" en su lugar.",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"method\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de \"función\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"constructor\".",
		"Cuando se activa IntelliSense muestra sugerencias \"obsoletas\".",
		"Cuando se activa el filtro IntelliSense se requiere que el primer carácter coincida con el inicio de una palabra. Por ejemplo, \"c\" en \"Consola\" o \"WebContext\" but _not_ on \"descripción\". Si se desactiva, IntelliSense mostrará más resultados, pero los ordenará según la calidad de la coincidencia.",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"field\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"variable\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"class\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"struct\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"interface\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"module\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"property\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"event\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"operator\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"unit\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de \"value\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"constant\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"enum\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"enumMember\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"keyword\".",
		"Si está habilitado, IntelliSense muestra sugerencias de tipo \"text\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de \"color\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"file\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"reference\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"customcolor\".",
		"Si está habilitado, IntelliSense muestra sugerencias de tipo \"folder\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"typeParameter\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias de tipo \"snippet\".",
		"Cuando está habilitado, IntelliSense muestra sugerencias del usuario.",
		"Cuando está habilitado IntelliSense muestra sugerencias para problemas.",
		"Indica si los espacios en blanco iniciales y finales deben seleccionarse siempre.",
		"Indica si se deben seleccionar las subpalabras (como \"foo\" en \"fooBar\" o \"foo_bar\").",
		"Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.).",
		"Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.).",
		"No hay sangría. Las líneas ajustadas comienzan en la columna 1.",
		"A las líneas ajustadas se les aplica la misma sangría que al elemento primario.",
		"A las líneas ajustadas se les aplica una sangría de +1 respecto al elemento primario.",
		"A las líneas ajustadas se les aplica una sangría de +2 respecto al elemento primario.",
		"Controla la sangría de las líneas ajustadas.",
		"Controla si puede arrastrar y colocar un archivo en un editor de texto manteniendo presionada la tecla \"Mayús\" (en lugar de abrir el archivo en un editor).",
		"Controla si se muestra un widget al colocar archivos en el editor. Este widget le permite controlar cómo se coloca el archivo.",
		"Muestra el widget del selector de colocación después de colocar un archivo en el editor.",
		"No mostrar nunca el widget del selector de colocación. En su lugar, siempre se usa el proveedor de colocación predeterminado.",
		"Controla si se puede pegar contenido de distintas formas.",
		"Controla si se muestra un widget al pegar contenido en el editor. Este widget le permite controlar cómo se pega el archivo.",
		"Muestra el widget del selector de pegado después de pegar contenido en el editor.",
		"No mostrar nunca el widget del selector de pegado. En su lugar, siempre se usa el comportamiento de pegado predeterminado.",
		"Controla si se deben aceptar sugerencias en los caracteres de confirmación. Por ejemplo, en Javascript, el punto y coma (\";\") puede ser un carácter de confirmación que acepta una sugerencia y escribe ese carácter.",
		"Aceptar solo una sugerencia con \"Entrar\" cuando realiza un cambio textual.",
		"Controla si las sugerencias deben aceptarse con \"Entrar\", además de \"TAB\". Ayuda a evitar la ambigüedad entre insertar nuevas líneas o aceptar sugerencias.",
		"Controla el número de líneas del editor que pueden ser leídas por un lector de pantalla a la vez. Cuando detectamos un lector de pantalla, fijamos automáticamente el valor por defecto en 500. Advertencia: esto tiene una implicación de rendimiento para números mayores que el predeterminado.",
		"Contenido del editor",
		"Controlar si un lector de pantalla anuncia sugerencias insertadas.",
		"Utilizar las configuraciones del lenguaje para determinar cuándo cerrar los corchetes automáticamente.",
		"Cerrar automáticamente los corchetes cuando el cursor esté a la izquierda de un espacio en blanco.",
		"Controla si el editor debe cerrar automáticamente los corchetes después de que el usuario agregue un corchete de apertura.",
		"Utilice las configuraciones de idioma para determinar cuándo cerrar los comentarios automáticamente.",
		"Cerrar automáticamente los comentarios solo cuando el cursor esté a la izquierda de un espacio en blanco.",
		"Controla si el editor debe cerrar automáticamente los comentarios después de que el usuario agregue un comentario de apertura.",
		"Quite los corchetes o las comillas de cierre adyacentes solo si se insertaron automáticamente.",
		"Controla si el editor debe quitar los corchetes o las comillas de cierre adyacentes al eliminar.",
		"Escriba en las comillas o los corchetes solo si se insertaron automáticamente.",
		"Controla si el editor debe escribir entre comillas o corchetes.",
		"Utilizar las configuraciones del lenguaje para determinar cuándo cerrar las comillas automáticamente. ",
		"Cerrar automáticamente las comillas cuando el cursor esté a la izquierda de un espacio en blanco. ",
		"Controla si el editor debe cerrar automáticamente las comillas después de que el usuario agrega uma comilla de apertura.",
		"El editor no insertará la sangría automáticamente.",
		"El editor mantendrá la sangría de la línea actual.",
		"El editor respetará la sangría de la línea actual y los corchetes definidos por el idioma.",
		"El editor mantendrá la sangría de la línea actual, respetará los corchetes definidos por el idioma e invocará onEnterRules especiales definidos por idiomas.",
		"El editor respetará la sangría de la línea actual, los corchetes definidos por idiomas y las reglas indentationRules definidas por idiomas, además de invocar reglas onEnterRules especiales.",
		"Controla si el editor debe ajustar automáticamente la sangría mientras los usuarios escriben, pegan, mueven o sangran líneas.",
		"Use las configuraciones de idioma para determinar cuándo delimitar las selecciones automáticamente.",
		"Envolver con comillas, pero no con corchetes.",
		"Envolver con corchetes, pero no con comillas.",
		"Controla si el editor debe rodear automáticamente las selecciones al escribir comillas o corchetes.",
		"Emula el comportamiento de selección de los caracteres de tabulación al usar espacios para la sangría. La selección se aplicará a las tabulaciones.",
		"Controla si el editor muestra CodeLens.",
		"Controla la familia de fuentes para CodeLens.",
		"Controla el tamaño de fuente de CodeLens en píxeles. Cuando se establece en 0, se usa el 90 % de \"#editor.fontSize#\".",
		"Controla si el editor debe representar el Selector de colores y los elementos Decorator de color en línea.",
		"Hacer que el selector de colores aparezca tanto al hacer clic como al mantener el puntero sobre el decorador de color",
		"Hacer que el selector de colores aparezca al pasar el puntero sobre el decorador de color",
		"Hacer que el selector de colores aparezca al hacer clic en el decorador de color",
		"Controla la condición para que un selector de colores aparezca de un decorador de color",
		"Controla el número máximo de decoradores de color que se pueden representar en un editor a la vez.",
		"Habilite que la selección con el mouse y las teclas esté realizando la selección de columnas.",
		"Controla si el resaltado de sintaxis debe ser copiado al portapapeles.",
		"Controla el estilo de animación del cursor.",
		"La animación del símbolo de intercalación suave está deshabilitada.",
		"La animación de símbolo de intercalación suave solo se habilita cuando el usuario mueve el cursor con un gesto explícito.",
		"La animación de símbolo de intercalación suave siempre está habilitada.",
		"Controla si la animación suave del cursor debe estar habilitada.",
		"Controla el estilo del cursor.",
		"Controla el número mínimo de líneas iniciales visibles (mínimo 0) y líneas finales (mínimo 1) que rodean el cursor. Se conoce como \"scrollOff\" o \"scrollOffset\" en otros editores.",
		"Solo se aplica \"cursorSurroundingLines\" cuando se desencadena mediante el teclado o la API.",
		"\"cursorSurroundingLines\" se aplica siempre.",
		"Controls when `#editor.cursorSurroundingLines#` should be enforced.",
		"Controla el ancho del cursor cuando \"#editor.cursorStyle#\" se establece en \"line\".",
		"Controla si el editor debe permitir mover las selecciones mediante arrastrar y colocar.",
		"Use un nuevo método de representación con svgs.",
		"Use un nuevo método de representación con caracteres de fuente.",
		"Use el método de representación estable.",
		"Controla si los espacios en blanco se representan con un nuevo método experimental.",
		"Multiplicador de la velocidad de desplazamiento al presionar \"Alt\".",
		"Controla si el editor tiene el plegado de código habilitado.",
		"Utilice una estrategia de plegado específica del idioma, si está disponible, de lo contrario la basada en sangría.",
		"Utilice la estrategia de plegado basada en sangría.",
		"Controla la estrategia para calcular rangos de plegado.",
		"Controla si el editor debe destacar los rangos plegados.",
		"Permite controlar si el editor contrae automáticamente los rangos de importación.",
		"Número máximo de regiones plegables. Si aumenta este valor, es posible que el editor tenga menos capacidad de respuesta cuando el origen actual tiene un gran número de regiones plegables.",
		"Controla si al hacer clic en el contenido vacío después de una línea plegada se desplegará la línea.",
		"Controla la familia de fuentes.",
		"Controla si el editor debe dar formato automáticamente al contenido pegado. Debe haber disponible un formateador capaz de aplicar formato a un rango dentro de un documento. ",
		"Controla si el editor debe dar formato a la línea automáticamente después de escribirla.",
		"Controla si el editor debe representar el margen de glifo vertical. El margen de glifo se usa, principalmente, para depuración.",
		"Controla si el cursor debe ocultarse en la regla de información general.",
		"Controla el espacio entre letras en píxeles.",
		"Controla si el editor tiene habilitada la edición vinculada. Dependiendo del lenguaje, los símbolos relacionados (por ejemplo, las etiquetas HTML) se actualizan durante la edición.",
		"Controla si el editor debe detectar vínculos y hacerlos interactivos.",
		"Resaltar paréntesis coincidentes.",
		"Se usará un multiplicador en los eventos de desplazamiento de la rueda del mouse \"deltaX\" y \"deltaY\". ",
		"Acercar la fuente del editor al usar la rueda del mouse y mantener pulsado \'Cmd\'.",
		"Ampliar la fuente del editor cuando se use la rueda del mouse mientras se presiona \"Ctrl\".",
		"Combinar varios cursores cuando se solapan.",
		"Se asigna a \"Control\" en Windows y Linux y a \"Comando\" en macOS.",
		"Se asigna a \"Alt\" en Windows y Linux y a \"Opción\" en macOS.",
		"El modificador que se usará para agregar varios cursores con el mouse. Los gestos del mouse Ir a definición y Abrir vínculo se adaptarán de modo que no entren en conflicto con el [modificador multicursor](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).",
		"Cada cursor pega una única línea del texto.",
		"Cada cursor pega el texto completo.",
		"Controla el pegado cuando el recuento de líneas del texto pegado coincide con el recuento de cursores.",
		"Controla el número máximo de cursores que puede haber en un editor activo a la vez.",
		"No resalta las repeticiones.",
		"Resalta las repeticiones solo en el archivo actual.",
		"Experimental: Resalta las repeticiones en todos los archivos abiertos válidos.",
		"Controla si las repeticiones deben resaltarse en los archivos abiertos.",
		"Controla si debe dibujarse un borde alrededor de la regla de información general.",
		"Enfocar el árbol al abrir la inspección",
		"Enfocar el editor al abrir la inspección",
		"Controla si se debe enfocar el editor en línea o el árbol en el widget de vista.",
		"Controla si el gesto del mouse Ir a definición siempre abre el widget interactivo.",
		"Controla el retraso, en milisegundos, tras el cual aparecerán sugerencias rápidas.",
		"Controla si el editor cambia el nombre automáticamente en el tipo.",
		"En desuso. Utilice \"editor.linkedEditing\" en su lugar.",
		"Controla si el editor debe representar caracteres de control.",
		"Representar el número de la última línea cuando el archivo termina con un salto de línea.",
		"Resalta el medianil y la línea actual.",
		"Controla cómo debe representar el editor el resaltado de línea actual.",
		"Controla si el editor debe representar el resaltado de la línea actual solo cuando el editor está enfocado.",
		"Representa caracteres de espacio en blanco, excepto los espacios individuales entre palabras.",
		"Represente los caracteres de espacio en blanco solo en el texto seleccionado.",
		"Representa solo los caracteres de espacio en blanco al final.",
		"Controla la forma en que el editor debe representar los caracteres de espacio en blanco.",
		"Controla si las selecciones deberían tener las esquinas redondeadas.",
		"Controla el número de caracteres adicionales a partir del cual el editor se desplazará horizontalmente.",
		"Controla si el editor seguirá haciendo scroll después de la última línea.",
		"Desplácese solo a lo largo del eje predominante cuando se desplace vertical y horizontalmente al mismo tiempo. Evita la deriva horizontal cuando se desplaza verticalmente en un trackpad.",
		"Controla si el portapapeles principal de Linux debe admitirse.",
		"Controla si el editor debe destacar las coincidencias similares a la selección.",
		"Mostrar siempre los controles de plegado.",
		"No mostrar nunca los controles de plegado y reducir el tamaño del medianil.",
		"Mostrar solo los controles de plegado cuando el mouse está sobre el medianil.",
		"Controla cuándo se muestran los controles de plegado en el medianil.",
		"Controla el fundido de salida del código no usado.",
		"Controla las variables en desuso tachadas.",
		"Mostrar sugerencias de fragmentos de código por encima de otras sugerencias.",
		"Mostrar sugerencias de fragmentos de código por debajo de otras sugerencias.",
		"Mostrar sugerencias de fragmentos de código con otras sugerencias.",
		"No mostrar sugerencias de fragmentos de código.",
		"Controla si se muestran los fragmentos de código con otras sugerencias y cómo se ordenan.",
		"Controla si el editor se desplazará con una animación.",
		"Controla si se debe proporcionar la sugerencia de accesibilidad a los usuarios del lector de pantalla cuando se muestra una finalización insertada.",
		"Tamaño de fuente del widget de sugerencias. Cuando se establece en {0}, se usa el valor de {1}.",
		"Alto de línea para el widget de sugerencias. Cuando se establece en {0}, se usa el valor de {1}. El valor mínimo es 8.",
		"Controla si deben aparecer sugerencias de forma automática al escribir caracteres desencadenadores.",
		"Seleccionar siempre la primera sugerencia.",
		"Seleccione sugerencias recientes a menos que al escribir más se seleccione una, por ejemplo, \"console.| -> console.log\" porque \"log\" se ha completado recientemente.",
		"Seleccione sugerencias basadas en prefijos anteriores que han completado esas sugerencias, por ejemplo, \"co -> console\" y \"con -> const\".",
		"Controla cómo se preseleccionan las sugerencias cuando se muestra la lista,",
		"La pestaña se completará insertando la mejor sugerencia de coincidencia encontrada al presionar la pestaña",
		"Deshabilitar los complementos para pestañas.",
		"La pestaña se completa con fragmentos de código cuando su prefijo coincide. Funciona mejor cuando las \'quickSuggestions\' no están habilitadas.",
		"Habilita completar pestañas.",
		"Los terminadores de línea no habituales se quitan automáticamente.",
		"Los terminadores de línea no habituales se omiten.",
		"Advertencia de terminadores de línea inusuales que se quitarán.",
		"Quite los terminadores de línea inusuales que podrían provocar problemas.",
		"Spaces and tabs are inserted and deleted in alignment with tab stops.",
		"Use la regla de salto de línea predeterminada.",
		"Los saltos de palabra no deben usarse para texto chino, japonés o coreano (CJK). El comportamiento del texto distinto a CJK es el mismo que el normal.",
		"Controla las reglas de salto de palabra usadas para texto chino, japonés o coreano (CJK).",
		"Caracteres que se usarán como separadores de palabras al realizar operaciones o navegaciones relacionadas con palabras.",
		"Las líneas no se ajustarán nunca.",
		"Las líneas se ajustarán en el ancho de la ventanilla.",
		"Las líneas se ajustarán al valor de \"#editor.wordWrapColumn#\". ",
		"Las líneas se ajustarán al valor que sea inferior: el tamaño de la ventanilla o el valor de \"#editor.wordWrapColumn#\".",
		"Controla cómo deben ajustarse las líneas.",
		"Controla la columna de ajuste del editor cuando \"#editor.wordWrap#\" es \"wordWrapColumn\" o \"bounded\".",
		"Controla si las decoraciones de color en línea deben mostrarse con el proveedor de colores del documento predeterminado.",
		"Controla si el editor recibe las pestañas o las aplaza al área de trabajo para la navegación.",
	],
	"vs/editor/common/core/editorColorRegistry": [
		"Color de fondo para la línea resaltada en la posición del cursor.",
		"Color de fondo del borde alrededor de la línea en la posición del cursor.",
		"Color de fondo de rangos resaltados, como en abrir rápido y encontrar características. El color no debe ser opaco para no ocultar decoraciones subyacentes.",
		"Color de fondo del borde alrededor de los intervalos resaltados.",
		"Color de fondo del símbolo destacado, como Ir a definición o Ir al siguiente/anterior símbolo. El color no debe ser opaco para no ocultar la decoración subyacente.",
		"Color de fondo del borde alrededor de los símbolos resaltados.",
		"Color del cursor del editor.",
		"Color de fondo del cursor de edición. Permite personalizar el color del caracter solapado por el bloque del cursor.",
		"Color of the primary editor cursor when multiple cursors are present.",
		"The background color of the primary editor cursor when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.",
		"Color of secondary editor cursors when multiple cursors are present.",
		"The background color of secondary editor cursors when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.",
		"Color de los caracteres de espacio en blanco del editor.",
		"Color de números de línea del editor.",
		"Color de las guías de sangría del editor.",
		"\"editorIndentGuide.background\" está en desuso. Use \"editorIndentGuide.background1\" en su lugar.",
		"Color de las guías de sangría activas del editor.",
		"\"editorIndentGuide.activeBackground\" está en desuso. Use \"editorIndentGuide.activeBackground1\" en su lugar.",
		"Color de las guías de sangría del editor (1).",
		"Color de las guías de sangría del editor (2).",
		"Color de las guías de sangría del editor (3).",
		"Color de las guías de sangría del editor (4).",
		"Color de las guías de sangría del editor (5).",
		"Color de las guías de sangría del editor (6).",
		"Color de las guías de sangría del editor activo (1).",
		"Color de las guías de sangría del editor activo (2).",
		"Color de las guías de sangría del editor activo (3).",
		"Color de las guías de sangría del editor activo (4).",
		"Color de las guías de sangría del editor activo (5).",
		"Color de las guías de sangría del editor activo (6).",
		"Color del número de línea activa en el editor",
		"ID es obsoleto. Usar en lugar \'editorLineNumber.activeForeground\'. ",
		"Color del número de línea activa en el editor",
		"Color de la línea final del editor cuando editor.renderFinalNewline se establece en atenuado.",
		"Color de las reglas del editor",
		"Color principal de lentes de código en el editor",
		"Color de fondo tras corchetes coincidentes",
		"Color de bloques con corchetes coincidentes",
		"Color del borde de la regla de visión general.",
		"Color de fondo de la regla de información general del editor.",
		"Color de fondo del margen del editor. Este espacio contiene los márgenes de glifos y los números de línea.",
		"Color del borde de código fuente innecesario (sin usar) en el editor.",
		"Opacidad de código fuente innecesario (sin usar) en el editor. Por ejemplo, \"#000000c0\" representará el código con un 75 % de opacidad. Para temas de alto contraste, utilice el color del tema \'editorUnnecessaryCode.border\' para resaltar el código innecesario en vez de atenuarlo.",
		"Color del borde del texto fantasma en el editor.",
		"Color de primer plano del texto fantasma en el editor.",
		"Color de fondo del texto fantasma en el editor.",
		"Color de marcador de regla general para los destacados de rango. El color no debe ser opaco para no ocultar las decoraciones subyacentes.",
		"Color de marcador de regla de información general para errores. ",
		"Color de marcador de regla de información general para advertencias.",
		"Color de marcador de regla de información general para mensajes informativos. ",
		"Color de primer plano de los corchetes (1). Requiere que se habilite la coloración del par de corchetes.",
		"Color de primer plano de los corchetes (2). Requiere que se habilite la coloración del par de corchetes.",
		"Color de primer plano de los corchetes (3). Requiere que se habilite la coloración del par de corchetes.",
		"Color de primer plano de los corchetes (4). Requiere que se habilite la coloración del par de corchetes.",
		"Color de primer plano de los corchetes (5). Requiere que se habilite la coloración del par de corchetes.",
		"Color de primer plano de los corchetes (6). Requiere que se habilite la coloración del par de corchetes.",
		"Color de primer plano de corchetes inesperados.",
		"Color de fondo de las guías de par de corchetes inactivos (1). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes inactivos (2). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes inactivos (3). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes inactivos (4). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes inactivos (5). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes inactivos (6). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de pares de corchetes activos (1). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes activos (2). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de pares de corchetes activos (3). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes activos (4). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes activos (5). Requiere habilitar guías de par de corchetes.",
		"Color de fondo de las guías de par de corchetes activos (6). Requiere habilitar guías de par de corchetes.",
		"Color de borde usado para resaltar caracteres Unicode.",
		"Color de borde usado para resaltar caracteres unicode.",
	],
	"vs/editor/common/editorContextKeys": [
		"Si el texto del editor tiene el foco (el cursor parpadea)",
		"Si el editor o un widget del editor tiene el foco (por ejemplo, el foco está en el widget de búsqueda)",
		"Si un editor o una entrada de texto enriquecido tienen el foco (el cursor parpadea)",
		"Si el editor es de solo lectura",
		"Si el contexto es un editor de diferencias",
		"Si el contexto es un editor de diferencias incrustado",
		"Si el contexto es un editor de diferencias múltiples",
		"Si todos los archivos del editor de diferencias múltiples están contraídos",
		"Si el editor de diferencias tiene cambios",
		"Indica si se selecciona un bloque de código movido para la comparación",
		"Si el visor de diferencias accesible está visible",
		"Indica si se alcanza el punto de interrupción insertado en paralelo del editor de diferencias",
		"Whether inline mode is active",
		"Whether modified is writable in the diff editor",
		"Whether modified is writable in the diff editor",
		"The uri of the original document",
		"The uri of the modified document",
		"Si \"editor.columnSelection\" se ha habilitado",
		"Si el editor tiene texto seleccionado",
		"Si el editor tiene varias selecciones",
		"Si \"Tabulación\" moverá el foco fuera del editor",
		"Si el mantenimiento del puntero del editor es visible",
		"Si se centra el desplazamiento del editor",
		"Si el desplazamiento permanente está centrado",
		"Si el desplazamiento permanente está visible",
		"Si el selector de colores independiente está visible",
		"Si el selector de colores independiente está centrado",
		"Si el editor forma parte de otro más grande (por ejemplo, blocs de notas)",
		"Identificador de idioma del editor",
		"Si el editor tiene un proveedor de elementos de finalización",
		"Si el editor tiene un proveedor de acciones de código",
		"Si el editor tiene un proveedor de CodeLens",
		"Si el editor tiene un proveedor de definiciones",
		"Si el editor tiene un proveedor de declaraciones",
		"Si el editor tiene un proveedor de implementación",
		"Si el editor tiene un proveedor de definiciones de tipo",
		"Si el editor tiene un proveedor de contenido con mantenimiento del puntero",
		"Si el editor tiene un proveedor de resaltado de documentos",
		"Si el editor tiene un proveedor de símbolos de documentos",
		"Si el editor tiene un proveedor de referencia",
		"Si el editor tiene un proveedor de cambio de nombre",
		"Si el editor tiene un proveedor de ayuda de signatura",
		"Si el editor tiene un proveedor de sugerencias insertadas",
		"Si el editor tiene un proveedor de formatos de documento",
		"Si el editor tiene un proveedor de formatos de selección de documentos",
		"Si el editor tiene varios proveedores de formatos del documento",
		"Si el editor tiene varios proveedores de formato de la selección de documentos",
	],
	"vs/editor/common/languages": [
		"matriz",
		"booleano",
		"clase",
		"constante",
		"constructor",
		"enumeración",
		"miembro de la enumeración",
		"evento",
		"campo",
		"archivo",
		"función",
		"interfaz",
		"clave",
		"método",
		"módulo",
		"espacio de nombres",
		"NULL",
		"número",
		"objeto",
		"operador",
		"paquete",
		"propiedad",
		"cadena",
		"estructura",
		"parámetro de tipo",
		"variable",
		"{0} ({1})",
	],
	"vs/editor/common/languages/modesRegistry": [
		"Texto sin formato",
	],
	"vs/editor/common/model/editStack": [
		"Escribiendo",
	],
	"vs/editor/common/standaloneStrings": [
		"Desarrollador: inspeccionar tokens",
		"Vaya a Línea/Columna...",
		"Mostrar todos los proveedores de acceso rápido",
		"Paleta de comandos",
		"Mostrar y ejecutar comandos",
		"Ir a símbolo...",
		"Ir a símbolo por categoría...",
		"Contenido del editor",
		"Presione Alt+F1 para ver las opciones de accesibilidad.",
		"Alternar tema de contraste alto",
		"{0} ediciones realizadas en {1} archivos",
	],
	"vs/editor/common/viewLayout/viewLineRenderer": [
		"Mostrar más ({0})",
		"{0} caracteres",
	],
	"vs/editor/contrib/anchorSelect/browser/anchorSelect": [
		"Delimitador de la selección",
		"Delimitador establecido en {0}:{1}",
		"Establecer el delimitador de la selección",
		"Ir al delimitador de la selección",
		"Seleccionar desde el delimitador hasta el cursor",
		"Cancelar el delimitador de la selección",
	],
	"vs/editor/contrib/bracketMatching/browser/bracketMatching": [
		"Resumen color de marcador de regla para corchetes.",
		"Ir al corchete",
		"Seleccionar para corchete",
		"Quitar corchetes",
		"Ir al &&corchete",
		"Se selecciona el texto que está dentro, incluyendo los corchetes o las llaves",
	],
	"vs/editor/contrib/caretOperations/browser/caretOperations": [
		"Mover el texto seleccionado a la izquierda",
		"Mover el texto seleccionado a la derecha",
	],
	"vs/editor/contrib/caretOperations/browser/transpose": [
		"Transponer letras",
	],
	"vs/editor/contrib/clipboard/browser/clipboard": [
		"Cor&&tar",
		"Cortar",
		"Cortar",
		"Cortar",
		"&&Copiar",
		"Copiar",
		"Copiar",
		"Copiar",
		"&&Pegar",
		"Pegar",
		"Pegar",
		"Pegar",
		"Copiar con resaltado de sintaxis",
		"Copiar como",
		"Copiar como",
		"Compartir",
		"Compartir",
		"Compartir",
	],
	"vs/editor/contrib/codeAction/browser/codeAction": [
		"Se ha producido un error desconocido al aplicar la acción de código",
	],
	"vs/editor/contrib/codeAction/browser/codeActionCommands": [
		"Tipo de la acción de código que se va a ejecutar.",
		"Controla cuándo se aplican las acciones devueltas.",
		"Aplicar siempre la primera acción de código devuelto.",
		"Aplicar la primera acción de código devuelta si solo hay una.",
		"No aplique las acciones de código devuelto.",
		"Controla si solo se deben devolver las acciones de código preferidas.",
		"Corrección Rápida",
		"No hay acciones de código disponibles",
		"No hay acciones de código preferidas para \"{0}\" disponibles",
		"No hay ninguna acción de código para \"{0}\" disponible.",
		"No hay acciones de código preferidas disponibles",
		"No hay acciones de código disponibles",
		"Refactorizar...",
		"No hay refactorizaciones preferidas de \"{0}\" disponibles",
		"No hay refactorizaciones de \"{0}\" disponibles",
		"No hay ninguna refactorización favorita disponible.",
		"No hay refactorizaciones disponibles",
		"Acción de código fuente...",
		"No hay acciones de origen preferidas para \"{0}\" disponibles",
		"No hay ninguna acción de código fuente para \"{0}\" disponible.",
		"No hay ninguna acción de código fuente favorita disponible.",
		"No hay acciones de origen disponibles",
		"Organizar Importaciones",
		"No hay acciones de importación disponibles",
		"Corregir todo",
		"No está disponible la acción de corregir todo",
		"Corregir automáticamente...",
		"No hay autocorrecciones disponibles",
	],
	"vs/editor/contrib/codeAction/browser/codeActionContributions": [
		"Activar/desactivar la visualización de los encabezados de los grupos en el menú de Acción de código.",
		"Habilita o deshabilita la visualización de la corrección rápida más cercana dentro de una línea cuando no está actualmente en un diagnóstico.",
	],
	"vs/editor/contrib/codeAction/browser/codeActionController": [
		"Contexto: {0} en la línea {1} y columna {2}.",
		"Ocultar deshabilitado",
		"Mostrar elementos deshabilitados",
	],
	"vs/editor/contrib/codeAction/browser/codeActionMenu": [
		"Más Acciones...",
		"Corrección rápida",
		"Extraer",
		"Insertado",
		"Reescribir",
		"Mover",
		"Delimitar con",
		"Acción de origen",
	],
	"vs/editor/contrib/codeAction/browser/lightBulbWidget": [
		"Ejecutar: {0}",
		"Mostrar acciones de código. Corrección rápida preferida disponible ({0})",
		"Mostrar acciones de código ({0})",
		"Mostrar acciones de código",
	],
	"vs/editor/contrib/codelens/browser/codelensController": [
		"Mostrar comandos de lente de código para la línea actual",
		"Seleccionar un comando",
	],
	"vs/editor/contrib/colorPicker/browser/colorPickerWidget": [
		"Haga clic para alternar las opciones de color (rgb/hsl/hex)",
		"Icono para cerrar el selector de colores",
	],
	"vs/editor/contrib/colorPicker/browser/standaloneColorPickerActions": [
		"&Mostrar o centrar Selector de colores independientes",
		"Ocultar la Selector de colores",
		"Insertar color con Selector de colores independiente",
		"Mostrar o centrar Selector de colores independientes",
		"Show or focus a standalone color picker which uses the default color provider. It displays hex/rgb/hsl colors.",
		"Hide the standalone color picker.",
		"Insert hex/rgb/hsl colors with the focused standalone color picker.",
	],
	"vs/editor/contrib/comment/browser/comment": [
		"Alternar comentario de línea",
		"&&Alternar comentario de línea",
		"Agregar comentario de línea",
		"Quitar comentario de línea",
		"Alternar comentario de bloque",
		"Alternar &&bloque de comentario",
	],
	"vs/editor/contrib/contextmenu/browser/contextmenu": [
		"Minimapa",
		"Representar caracteres",
		"Tamaño vertical",
		"Proporcional",
		"Relleno",
		"Ajustar",
		"Control deslizante",
		"Pasar el mouse",
		"Siempre",
		"Mostrar menú contextual del editor",
	],
	"vs/editor/contrib/cursorUndo/browser/cursorUndo": [
		"Cursor Deshacer",
		"Cursor Rehacer",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/copyPasteContribution": [
		"The kind of the paste edit to try applying. If not provided or there are multiple edits for this kind, the editor will show a picker.",
		"Pegar como...",
		"Pegar como texto",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/copyPasteController": [
		"Si se muestra el widget de pegado",
		"Mostrar opciones de pegado...",
		"No se encontraron ediciones de pegado para \'{0}\'",
		"Ejecutando controladores de pegado. Haga clic para cancelar.",
		"Seleccionar acción pegar",
		"Ejecutando controladores de pegado",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/defaultProviders": [
		"Insertar texto sin formato",
		"Insertar URIs",
		"Insertar URI",
		"Insertar rutas de acceso",
		"Insertar ruta de acceso",
		"Insertar rutas de acceso relativas",
		"Insertar ruta de acceso relativa",
		"Insertar HTML",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/dropIntoEditorContribution": [
		"Configura el proveedor de colocación predeterminado que se usará para el contenido de un tipo MIME determinado.",
	],
	"vs/editor/contrib/dropOrPasteInto/browser/dropIntoEditorController": [
		"Si se muestra el widget de colocación",
		"Mostrar opciones de colocación...",
		"Ejecutando controladores de colocación. Haga clic para cancelar.",
	],
	"vs/editor/contrib/editorState/browser/keybindingCancellation": [
		"Indica si el editor ejecuta una operación que se puede cancelar como, por ejemplo, \"Inspeccionar referencias\"",
	],
	"vs/editor/contrib/find/browser/findController": [
		"El archivo es demasiado grande para realizar una operación de reemplazar todo.",
		"Buscar",
		"&&Buscar",
		"Búsqueda con argumentos",
		"Buscar con selección",
		"Buscar siguiente",
		"Buscar anterior",
		"Ir a Coincidencia...",
		"No hay coincidencias. Intente buscar otra cosa.",
		"Escriba un número para ir a una coincidencia específica (entre 1 y {0})",
		"Escriba un número entre 1 y {0}",
		"Escriba un número entre 1 y {0}",
		"Buscar selección siguiente",
		"Buscar selección anterior",
		"Reemplazar",
		"&&Reemplazar",
	],
	"vs/editor/contrib/find/browser/findWidget": [
		"Icono para \"Buscar en selección\" en el widget de búsqueda del editor.",
		"Icono para indicar que el widget de búsqueda del editor está contraído.",
		"Icono para indicar que el widget de búsqueda del editor está expandido.",
		"Icono para \"Reemplazar\" en el widget de búsqueda del editor.",
		"Icono para \"Reemplazar todo\" en el widget de búsqueda del editor.",
		"Icono para \"Buscar anterior\" en el widget de búsqueda del editor.",
		"Icono para \"Buscar siguiente\" en el widget de búsqueda del editor.",
		"Buscar y reemplazar",
		"Buscar",
		"Buscar",
		"Coincidencia anterior",
		"Coincidencia siguiente",
		"Buscar en selección",
		"Cerrar",
		"Reemplazar",
		"Reemplazar",
		"Reemplazar",
		"Reemplazar todo",
		"Alternar reemplazar",
		"Sólo los primeros {0} resultados son resaltados, pero todas las operaciones de búsqueda trabajan en todo el texto.",
		"{0} de {1}",
		"No hay resultados",
		"Encontrados: {0}",
		"{0} encontrado para \"{1}\"",
		"{0} encontrado para \"{1}\", en {2}",
		"{0} encontrado para \"{1}\"",
		"Ctrl+Entrar ahora inserta un salto de línea en lugar de reemplazar todo. Puede modificar el enlace de claves para editor.action.replaceAll para invalidar este comportamiento.",
	],
	"vs/editor/contrib/folding/browser/folding": [
		"Desplegar",
		"Desplegar de forma recursiva",
		"Plegar",
		"Alternar plegado",
		"Plegar de forma recursiva",
		"Cerrar todos los comentarios de bloque",
		"Plegar todas las regiones",
		"Desplegar Todas las Regiones",
		"Plegar todas excepto las seleccionadas",
		"Desplegar todas excepto las seleccionadas",
		"Plegar todo",
		"Desplegar todo",
		"Ir al plegado primario",
		"Ir al rango de plegado anterior",
		"Ir al rango de plegado siguiente",
		"Crear rango de plegado a partir de la selección",
		"Quitar rangos de plegado manuales",
		"Nivel de plegamiento {0}",
	],
	"vs/editor/contrib/folding/browser/foldingDecorations": [
		"Color de fondo detrás de los rangos plegados. El color no debe ser opaco para no ocultar las decoraciones subyacentes.",
		"Color del control plegable en el medianil del editor.",
		"Icono de rangos expandidos en el margen de glifo del editor.",
		"Icono de rangos contraídos en el margen de glifo del editor.",
		"Icono de intervalos contraídos manualmente en el margen del glifo del editor.",
		"Icono de intervalos expandidos manualmente en el margen del glifo del editor.",
		"Haga clic para expandir el rango.",
		"Haga clic para contraer el intervalo.",
	],
	"vs/editor/contrib/fontZoom/browser/fontZoom": [
		"Aumentar el tamaño de fuente del editor",
		"Disminuir el tamaño de fuente del editor",
		"Restablecer tamaño de fuente del editor",
	],
	"vs/editor/contrib/format/browser/formatActions": [
		"Dar formato al documento",
		"Dar formato a la selección",
	],
	"vs/editor/contrib/gotoError/browser/gotoError": [
		"Ir al siguiente problema (Error, Advertencia, Información)",
		"Icono para ir al marcador siguiente.",
		"Ir al problema anterior (Error, Advertencia, Información)",
		"Icono para ir al marcador anterior.",
		"Ir al siguiente problema en Archivos (Error, Advertencia, Información)",
		"Siguiente &&problema",
		"Ir al problema anterior en Archivos (Error, Advertencia, Información)",
		"Anterior &&problema",
	],
	"vs/editor/contrib/gotoError/browser/gotoErrorWidget": [
		"Error",
		"Advertencia",
		"Información",
		"Sugerencia",
		"{0} en {1}. ",
		"{0} de {1} problemas",
		"{0} de {1} problema",
		"Color de los errores del widget de navegación de marcadores del editor.",
		"Fondo del encabezado del error del widget de navegación del marcador de editor.",
		"Color de las advertencias del widget de navegación de marcadores del editor.",
		"Fondo del encabezado de la advertencia del widget de navegación del marcador de editor.",
		"Color del widget informativo marcador de navegación en el editor.",
		"Fondo del encabezado de información del widget de navegación del marcador de editor.",
		"Fondo del widget de navegación de marcadores del editor.",
	],
	"vs/editor/contrib/gotoSymbol/browser/goToCommands": [
		"Ver",
		"Definiciones",
		"No se encontró ninguna definición para \"{0}\"",
		"No se encontró ninguna definición",
		"Ir a &&definición",
		"Declaraciones",
		"No se encontró ninguna definición para \'{0}\'",
		"No se encontró ninguna declaración",
		"Ir a &&declaración",
		"No se encontró ninguna definición para \'{0}\'",
		"No se encontró ninguna declaración",
		"Definiciones de tipo",
		"No se encontró ninguna definición de tipo para \"{0}\"",
		"No se encontró ninguna definición de tipo",
		"Ir a la definición de &&tipo",
		"Implementaciones",
		"No se encontró ninguna implementación para \"{0}\"",
		"No se encontró ninguna implementación",
		"Ir a &&implementaciones",
		"No se ha encontrado ninguna referencia para \"{0}\".",
		"No se encontraron referencias",
		"Ir a &&referencias",
		"Referencias",
		"Referencias",
		"Ubicaciones",
		"No hay resultados para \"{0}\"",
		"Referencias",
		"Ir a definición",
		"Abrir definición en el lateral",
		"Ver la definición sin salir",
		"Ir a Definición",
		"Inspeccionar Definición",
		"Ir a la definición de tipo",
		"Inspeccionar definición de tipo",
		"Ir a Implementaciones",
		"Inspeccionar implementaciones",
		"Ir a Referencias",
		"Inspeccionar Referencias",
		"Ir a cualquier símbolo",
	],
	"vs/editor/contrib/gotoSymbol/browser/link/goToDefinitionAtPosition": [
		"Haga clic para mostrar {0} definiciones.",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesController": [
		"Indica si está visible la inspección de referencias, como \"Inspección de referencias\" o \"Ver la definición sin salir\".",
		"Cargando...",
		"{0} ({1})",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesTree": [
		"{0} referencias",
		"{0} referencia",
		"Referencias",
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesWidget": [
		"vista previa no disponible",
		"No hay resultados",
		"Referencias",
	],
	"vs/editor/contrib/gotoSymbol/browser/referencesModel": [
		"en {0} en la línea {1} en la columna {2}",
		"{0} en {1} en la línea {2} en la columna {3}",
		"1 símbolo en {0}, ruta de acceso completa {1}",
		"{0} símbolos en {1}, ruta de acceso completa {2}",
		"No se encontraron resultados",
		"Encontró 1 símbolo en {0}",
		"Encontró {0} símbolos en {1}",
		"Encontró {0} símbolos en {1} archivos",
	],
	"vs/editor/contrib/gotoSymbol/browser/symbolNavigation": [
		"Indica si hay ubicaciones de símbolos a las que se pueda navegar solo con el teclado.",
		"Símbolo {0} de {1}, {2} para el siguiente",
		"Símbolo {0} de {1}",
	],
	"vs/editor/contrib/hover/browser/hoverActions": [
		"Show or Focus Hover",
		"The hover will not automatically take focus.",
		"The hover will take focus only if it is already visible.",
		"The hover will automatically take focus when it appears.",
		"Show Definition Preview Hover",
		"Scroll Up Hover",
		"Scroll Down Hover",
		"Scroll Left Hover",
		"Scroll Right Hover",
		"Page Up Hover",
		"Page Down Hover",
		"Go To Top Hover",
		"Go To Bottom Hover",
		"Increase Hover Verbosity Level",
		"Decrease Hover Verbosity Level",
		"Show or focus the editor hover which shows documentation, references, and other content for a symbol at the current cursor position.",
		"Show the definition preview hover in the editor.",
		"Scroll up the editor hover.",
		"Scroll down the editor hover.",
		"Scroll left the editor hover.",
		"Scroll right the editor hover.",
		"Page up the editor hover.",
		"Page down the editor hover.",
		"Go to the top of the editor hover.",
		"Go to the bottom of the editor hover.",
	],
	"vs/editor/contrib/hover/browser/markdownHoverParticipant": [
		"Icon for increaseing hover verbosity.",
		"Icon for decreasing hover verbosity.",
		"Cargando...",
		"Representación en pausa durante una línea larga por motivos de rendimiento. Esto se puede configurar mediante \"editor.stopRenderingLineAfter\".",
		"Por motivos de rendimiento, la tokenización se omite con filas largas. Esta opción se puede configurar con \"editor.maxTokenizationLineLength\".",
		"Increase Verbosity ({0})",
		"Increase Verbosity",
		"Decrease Verbosity ({0})",
		"Decrease Verbosity",
	],
	"vs/editor/contrib/hover/browser/markerHoverParticipant": [
		"Ver el problema",
		"No hay correcciones rápidas disponibles",
		"Buscando correcciones rápidas...",
		"No hay correcciones rápidas disponibles",
		"Corrección Rápida",
	],
	"vs/editor/contrib/inPlaceReplace/browser/inPlaceReplace": [
		"Reemplazar con el valor anterior",
		"Reemplazar con el valor siguiente",
	],
	"vs/editor/contrib/indentation/browser/indentation": [
		"Convertir sangría en espacios",
		"Convertir sangría en tabulaciones",
		"Tamaño de tabulación configurado",
		"Tamaño de tabulación predeterminado",
		"Tamaño de tabulación actual",
		"Seleccionar tamaño de tabulación para el archivo actual",
		"Aplicar sangría con tabulaciones",
		"Aplicar sangría con espacios",
		"Cambiar tamaño de visualización de tabulación",
		"Detectar sangría del contenido",
		"Volver a aplicar sangría a líneas",
		"Volver a aplicar sangría a líneas seleccionadas",
		"Convert the tab indentation to spaces.",
		"Convert the spaces indentation to tabs.",
		"Use indentation with tabs.",
		"Use indentation with spaces.",
		"Change the space size equivalent of the tab.",
		"Detect the indentation from content.",
		"Reindent the lines of the editor.",
		"Reindent the selected lines of the editor.",
	],
	"vs/editor/contrib/inlayHints/browser/inlayHintsHover": [
		"Haga doble clic para insertar",
		"cmd + clic",
		"ctrl + clic",
		"opción + clic",
		"alt + clic",
		"Ir a Definición ({0}), haga clic con el botón derecho para obtener más información",
		"Ir a Definición ({0})",
		"Ejecutar comando",
	],
	"vs/editor/contrib/inlineCompletions/browser/commands": [
		"Mostrar sugerencia alineada siguiente",
		"Mostrar sugerencia alineada anterior",
		"Desencadenar sugerencia alineada",
		"Aceptar la siguiente palabra de sugerencia insertada",
		"Aceptar palabra",
		"Aceptar la siguiente línea de sugerencia insertada",
		"Aceptar línea",
		"Aceptar la sugerencia insertada",
		"Aceptar",
		"Ocultar la sugerencia insertada",
		"Mostrar siempre la barra de herramientas",
	],
	"vs/editor/contrib/inlineCompletions/browser/hoverParticipant": [
		"Sugerencia:",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionContextKeys": [
		"Si una sugerencia alineada está visible",
		"Si la sugerencia alineada comienza con un espacio en blanco",
		"Si la sugerencia insertada comienza con un espacio en blanco menor que lo que se insertaría mediante tabulación",
		"Si las sugerencias deben suprimirse para la sugerencia actual",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionsController": [
		"Inspeccionar esto en la vista accesible ({0})",
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionsHintsWidget": [
		"Icono para mostrar la sugerencia de parámetro siguiente.",
		"Icono para mostrar la sugerencia de parámetro anterior.",
		"{0} ({1})",
		"Anterior",
		"Siguiente",
	],
	"vs/editor/contrib/lineSelection/browser/lineSelection": [
		"Expandir selección de línea",
	],
	"vs/editor/contrib/linesOperations/browser/linesOperations": [
		"Copiar línea arriba",
		"&&Copiar línea arriba",
		"Copiar línea abajo",
		"Co&&piar línea abajo",
		"Selección duplicada",
		"&&Duplicar selección",
		"Mover línea hacia arriba",
		"Mo&&ver línea arriba",
		"Mover línea hacia abajo",
		"Mover &&línea abajo",
		"Ordenar líneas en orden ascendente",
		"Ordenar líneas en orden descendente",
		"Eliminar líneas duplicadas",
		"Recortar espacio final",
		"Eliminar línea",
		"Sangría de línea",
		"Anular sangría de línea",
		"Insertar línea arriba",
		"Insertar línea debajo",
		"Eliminar todo a la izquierda",
		"Eliminar todo lo que está a la derecha",
		"Unir líneas",
		"Transponer caracteres alrededor del cursor",
		"Transformar a mayúsculas",
		"Transformar a minúsculas",
		"Transformar en Title Case",
		"Transformar en Snake Case",
		"Transformar a mayúsculas y minúsculas Camel",
		"Transform to Pascal Case",
		"Transformar en caso Kebab",
	],
	"vs/editor/contrib/linkedEditing/browser/linkedEditing": [
		"Iniciar edición vinculada",
		"Color de fondo cuando el editor cambia el nombre automáticamente al escribir.",
	],
	"vs/editor/contrib/links/browser/links": [
		"No se pudo abrir este vínculo porque no tiene un formato correcto: {0}",
		"No se pudo abrir este vínculo porque falta el destino.",
		"Ejecutar comando",
		"Seguir vínculo",
		"cmd + clic",
		"ctrl + clic",
		"opción + clic",
		"alt + clic",
		"Ejecutar el comando {0}",
		"Abrir vínculo",
	],
	"vs/editor/contrib/message/browser/messageController": [
		"Indica si el editor muestra actualmente un mensaje insertado",
	],
	"vs/editor/contrib/multicursor/browser/multicursor": [
		"Cursor agregado: {0}",
		"Cursores agregados: {0}",
		"Agregar cursor arriba",
		"&&Agregar cursor arriba",
		"Agregar cursor debajo",
		"A&&gregar cursor abajo",
		"Añadir cursores a finales de línea",
		"Agregar c&&ursores a extremos de línea",
		"Añadir cursores a la parte inferior",
		"Añadir cursores a la parte superior",
		"Agregar selección hasta la siguiente coincidencia de búsqueda",
		"Agregar &&siguiente repetición",
		"Agregar selección hasta la anterior coincidencia de búsqueda",
		"Agregar r&&epetición anterior",
		"Mover última selección hasta la siguiente coincidencia de búsqueda",
		"Mover última selección hasta la anterior coincidencia de búsqueda",
		"Seleccionar todas las repeticiones de coincidencia de búsqueda",
		"Seleccionar todas las &&repeticiones",
		"Cambiar todas las ocurrencias",
		"Enfocar el siguiente cursor",
		"Centra el cursor siguiente",
		"Enfocar cursor anterior",
		"Centra el cursor anterior",
	],
	"vs/editor/contrib/parameterHints/browser/parameterHints": [
		"Sugerencias para parámetros Trigger",
	],
	"vs/editor/contrib/parameterHints/browser/parameterHintsWidget": [
		"Icono para mostrar la sugerencia de parámetro siguiente.",
		"Icono para mostrar la sugerencia de parámetro anterior.",
		"{0}, sugerencia",
		"Color de primer plano del elemento activo en la sugerencia de parámetro.",
	],
	"vs/editor/contrib/peekView/browser/peekView": [
		"Indica si el editor de código actual está incrustado en la inspección.",
		"Cerrar",
		"Color de fondo del área de título de la vista de inspección.",
		"Color del título de la vista de inpección.",
		"Color de la información del título de la vista de inspección.",
		"Color de los bordes y la flecha de la vista de inspección.",
		"Color de fondo de la lista de resultados de vista de inspección.",
		"Color de primer plano de los nodos de inspección en la lista de resultados.",
		"Color de primer plano de los archivos de inspección en la lista de resultados.",
		"Color de fondo de la entrada seleccionada en la lista de resultados de vista de inspección.",
		"Color de primer plano de la entrada seleccionada en la lista de resultados de vista de inspección.",
		"Color de fondo del editor de vista de inspección.",
		"Color de fondo del margen en el editor de vista de inspección.",
		"Color de fondo del desplazamiento permanente en el editor de vista de inspección.",
		"Buscar coincidencia con el color de resaltado de la lista de resultados de vista de inspección.",
		"Buscar coincidencia del color de resultado del editor de vista de inspección.",
		"Hacer coincidir el borde resaltado en el editor de vista previa.",
	],
	"vs/editor/contrib/quickAccess/browser/gotoLineQuickAccess": [
		"Abra primero un editor de texto para ir a una línea.",
		"Vaya a la línea {0} y al carácter {1}.",
		"Ir a la línea {0}.",
		"Línea actual: {0}, Carácter: {1}. Escriba un número de línea entre 1 y {2} a los que navegar.",
		"Línea actual: {0}, Carácter: {1}. Escriba un número de línea al que navegar.",
	],
	"vs/editor/contrib/quickAccess/browser/gotoSymbolQuickAccess": [
		"Para ir a un símbolo, primero abra un editor de texto con información de símbolo.",
		"El editor de texto activo no proporciona información de símbolos.",
		"No hay ningún símbolo del editor coincidente.",
		"No hay símbolos del editor.",
		"Abrir en el lateral",
		"Abrir en la parte inferior",
		"símbolos ({0})",
		"propiedades ({0})",
		"métodos ({0})",
		"funciones ({0})",
		"constructores ({0})",
		"variables ({0})",
		"clases ({0})",
		"estructuras ({0})",
		"eventos ({0})",
		"operadores ({0})",
		"interfaces ({0})",
		"espacios de nombres ({0})",
		"paquetes ({0})",
		"parámetros de tipo ({0})",
		"módulos ({0})",
		"propiedades ({0})",
		"enumeraciones ({0})",
		"miembros de enumeración ({0})",
		"cadenas ({0})",
		"archivos ({0})",
		"matrices ({0})",
		"números ({0})",
		"booleanos ({0})",
		"objetos ({0})",
		"claves ({0})",
		"campos ({0})",
		"constantes ({0})",
	],
	"vs/editor/contrib/readOnlyMessage/browser/contribution": [
		"No se puede editar en la entrada de solo lectura",
		"No se puede editar en un editor de sólo lectura",
	],
	"vs/editor/contrib/rename/browser/rename": [
		"No hay ningún resultado.",
		"Error desconocido al resolver el cambio de nombre de la ubicación",
		"Cambiando el nombre de \'{0}\' a \'{1}\'",
		"Cambiar el nombre de {0} a {1}",
		"Nombre cambiado correctamente de \'{0}\' a \'{1}\'. Resumen: {2}",
		"No se pudo cambiar el nombre a las ediciones de aplicación",
		"No se pudo cambiar el nombre de las ediciones de cálculo",
		"Cambiar el nombre del símbolo",
		"Activar/desactivar la capacidad de previsualizar los cambios antes de cambiar el nombre",
		"Enfocar la siguiente sugerencia de cambio de nombre",
		"Enfocar sugerencia de cambio de nombre anterior",
	],
	"vs/editor/contrib/rename/browser/renameWidget": [
		"Whether the rename input widget is visible",
		"Whether the rename input widget is focused",
		"{0} to Rename, {1} to Preview",
		"Received {0} rename suggestions",
		"Rename input. Type new name and press Enter to commit.",
		"Generate new name suggestions",
		"Cancel",
	],
	"vs/editor/contrib/smartSelect/browser/smartSelect": [
		"Expandir selección",
		"&&Expandir selección",
		"Reducir la selección",
		"&&Reducir selección",
	],
	"vs/editor/contrib/snippet/browser/snippetController2": [
		"Indica si el editor actual está en modo de fragmentos de código.",
		"Indica si hay una tabulación siguiente cuando se está en modo de fragmentos de código.",
		"Si hay una tabulación anterior cuando se está en modo de fragmentos de código.",
		"Ir al marcador de posición siguiente...",
	],
	"vs/editor/contrib/snippet/browser/snippetVariables": [
		"Domingo",
		"Lunes",
		"Martes",
		"Miércoles",
		"Jueves",
		"Viernes",
		"Sábado",
		"Dom",
		"Lun",
		"Mar",
		"Mié",
		"Jue",
		"Vie",
		"Sáb",
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"May",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre",
		"Ene",
		"Feb",
		"Mar",
		"Abr",
		"May",
		"Jun",
		"Jul",
		"Ago",
		"Sep",
		"Oct",
		"Nov",
		"Dic",
	],
	"vs/editor/contrib/stickyScroll/browser/stickyScrollActions": [
		"&&Alternar desplazamiento permanente del editor",
		"Desplazamiento permanente",
		"&&Desplazamiento permanente",
		"&&Desplazamiento permanente de foco",
		"Alternar desplazamiento Sticky del editor",
		"Toggle/enable the editor sticky scroll which shows the nested scopes at the top of the viewport",
		"Focus on the editor sticky scroll",
		"Select the next editor sticky scroll line",
		"Select the previous sticky scroll line",
		"Go to the focused sticky scroll line",
		"Seleccionar el Editor",
	],
	"vs/editor/contrib/suggest/browser/suggest": [
		"Si alguna sugerencia tiene el foco",
		"Indica si los detalles de las sugerencias están visibles.",
		"Indica si hay varias sugerencias para elegir.",
		"Indica si la inserción de la sugerencia actual genera un cambio o si ya se ha escrito todo.",
		"Indica si se insertan sugerencias al presionar Entrar.",
		"Indica si la sugerencia actual tiene el comportamiento de inserción y reemplazo.",
		"Indica si el comportamiento predeterminado es insertar o reemplazar.",
		"Indica si la sugerencia actual admite la resolución de más detalles.",
	],
	"vs/editor/contrib/suggest/browser/suggestController": [
		"Aceptando \"{0}\" ediciones adicionales de {1} realizadas",
		"Sugerencias para Trigger",
		"Insertar",
		"Insertar",
		"Reemplazar",
		"Reemplazar",
		"Insertar",
		"mostrar menos",
		"mostrar más",
		"Restablecer tamaño del widget de sugerencias",
	],
	"vs/editor/contrib/suggest/browser/suggestWidget": [
		"Color de fondo del widget sugerido.",
		"Color de borde del widget sugerido.",
		"Color de primer plano del widget sugerido.",
		"Color de primer plano de le entrada seleccionada del widget de sugerencias.",
		"Color de primer plano del icono de la entrada seleccionada en el widget de sugerencias.",
		"Color de fondo de la entrada seleccionada del widget sugerido.",
		"Color del resaltado coincidido en el widget sugerido.",
		"Color de los resaltados de coincidencia en el widget de sugerencias cuando se enfoca un elemento.",
		"Color de primer plano del estado del widget sugerido.",
		"Cargando...",
		"No hay sugerencias.",
		"Sugerir",
		"{0} {1}, {2}",
		"{0} {1}",
		"{0}, {1}",
		"{0}, documentos: {1}",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetDetails": [
		"Cerrar",
		"Cargando...",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetRenderer": [
		"Icono para obtener más información en el widget de sugerencias.",
		"Leer más",
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetStatus": [
		"{0} ({1})",
	],
	"vs/editor/contrib/symbolIcons/browser/symbolIcons": [
		"Color de primer plano de los símbolos de matriz. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos booleanos. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de clase. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de color. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos constantes. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de constructor. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de enumerador. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de miembro del enumerador. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de evento. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de campo. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de archivo. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de carpeta. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de función. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de interfaz. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de claves. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de palabra clave. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de método. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de módulo. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de espacio de nombres. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos nulos. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano para los símbolos numéricos. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de objeto. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano para los símbolos del operador. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de paquete. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de propiedad. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de referencia. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de fragmento de código. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de cadena. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de estructura. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de texto. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano para los símbolos de parámetro de tipo. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos de unidad. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
		"Color de primer plano de los símbolos variables. Estos símbolos aparecen en el contorno, la ruta de navegación y el widget de sugerencias.",
	],
	"vs/editor/contrib/toggleTabFocusMode/browser/toggleTabFocusMode": [
		"Presionando la pestaña ahora moverá el foco al siguiente elemento enfocable.",
		"Presionando la pestaña ahora insertará el carácter de tabulación",
		"Alternar tecla de tabulación para mover el punto de atención",
		"Determines whether the tab key moves focus around the workbench or inserts the tab character in the current editor. This is also called tab trapping, tab navigation, or tab focus mode.",
	],
	"vs/editor/contrib/tokenization/browser/tokenization": [
		"Desarrollador: forzar nueva aplicación de token",
	],
	"vs/editor/contrib/unicodeHighlighter/browser/unicodeHighlighter": [
		"Icono que se muestra con un mensaje de advertencia en el editor de extensiones.",
		"Este documento contiene muchos caracteres Unicode ASCII no básicos",
		"Este documento contiene muchos caracteres Unicode ambiguos",
		"Este documento contiene muchos caracteres Unicode invisibles",
		"Configurar opciones de resaltado Unicode",
		"El carácter {0} podría confundirse con el carácter ASCII {1}, que es más común en el código fuente.",
		"El carácter {0} podría confundirse con el carácter {1}, que es más común en el código fuente.",
		"El carácter {0} es invisible.",
		"El carácter {0} no es un carácter ASCII básico.",
		"Ajustar la configuración",
		"Deshabilitar resaltado en comentarios",
		"Deshabilitar resaltado de caracteres en comentarios",
		"Deshabilitar resaltado en cadenas",
		"Deshabilitar resaltado de caracteres en cadenas",
		"Deshabilitar resaltado ambiguo",
		"Deshabilitar el resaltado de caracteres ambiguos",
		"Deshabilitar resaltado invisible",
		"Deshabilitar el resaltado de caracteres invisibles",
		"Deshabilitar resaltado que no es ASCII",
		"Deshabilitar el resaltado de caracteres ASCII no básicos",
		"Mostrar opciones de exclusión",
		"Excluir {0} (carácter invisible) de que se resalte",
		"Excluir {0} de ser resaltado",
		"Permite caracteres Unicode más comunes en el idioma \"{0}\".",
	],
	"vs/editor/contrib/unusualLineTerminators/browser/unusualLineTerminators": [
		"Terminadores de línea inusuales",
		"Se han detectado terminadores de línea inusuales",
		"Este archivo \"{0}\" contiene uno o más caracteres de terminación de línea inusuales, como el separador de línea (LS) o el separador de párrafo (PS).\r\n\r\nSe recomienda eliminarlos del archivo. Esto puede configurarse mediante \"editor.unusualLineTerminators\".",
		"&&Quitar terminadores de línea inusuales",
		"Omitir",
	],
	"vs/editor/contrib/wordHighlighter/browser/highlightDecorations": [
		"Color de fondo de un símbolo durante el acceso de lectura, como la lectura de una variable. El color no debe ser opaco para no ocultar decoraciones subyacentes.",
		"Color de fondo de un símbolo durante el acceso de escritura, como escribir en una variable. El color no debe ser opaco para no ocultar las decoraciones subyacentes.",
		"Color de fondo de la presencia textual para un símbolo. Para evitar ocultar cualquier decoración subyacente, el color no debe ser opaco.",
		"Color de fondo de un símbolo durante el acceso de lectura; por ejemplo, cuando se lee una variable.",
		"Color de fondo de un símbolo durante el acceso de escritura; por ejemplo, cuando se escribe una variable.",
		"Color de borde de una repetición textual de un símbolo.",
		"Color del marcador de regla general para destacados de símbolos. El color no debe ser opaco para no ocultar decoraciones subyacentes.",
		"Color de marcador de regla general para destacados de símbolos de acceso de escritura. El color no debe ser opaco para no ocultar las decoraciones subyacentes.",
		"Color del marcador de regla de información general de una repetición textual de un símbolo. El color no debe ser opaco para no ocultar las decoraciones subyacentes.",
	],
	"vs/editor/contrib/wordHighlighter/browser/wordHighlighter": [
		"Ir al siguiente símbolo destacado",
		"Ir al símbolo destacado anterior",
		"Desencadenar los símbolos destacados",
	],
	"vs/editor/contrib/wordOperations/browser/wordOperations": [
		"Eliminar palabra",
	],
	"vs/platform/accessibilitySignal/browser/accessibilitySignalService": [
		"Error at Position",
		"Error",
		"Warning at Position",
		"Warning",
		"Error en la línea",
		"Error on Line",
		"Advertencia en la línea",
		"Warning on Line",
		"Área doblada en la línea",
		"Contraída",
		"Punto de interrupción en la línea",
		"Punto de interrupción",
		"Sugerencia insertada en la línea",
		"Corrección rápida del terminal",
		"Corrección rápida",
		"Depurador detenido en el punto de interrupción",
		"Punto de interrupción",
		"No hay sugerencias de incrustación en la línea",
		"No hay sugerencias de incrustación",
		"Tarea completada.",
		"Tarea completada.",
		"Error en la tarea",
		"Error en la tarea",
		"Error del comando de terminal",
		"Error del comando",
		"Campana de terminal",
		"Campana de terminal",
		"Celda del bloc de notas completada",
		"Celda del bloc de notas completada",
		"Error en la celda del bloc de notas",
		"Error en la celda del bloc de notas",
		"Línea de diferencia insertada",
		"Línea de diferencia eliminada",
		"Línea de diferencia modificada",
		"Se envió una solicitud de chat",
		"Se envió una solicitud de chat",
		"Respuesta de chat recibida",
		"Progress",
		"Progress",
		"Borrar",
		"Borrar",
		"Guardar",
		"Guardar",
		"Formato",
		"Formato",
		"Voice Recording Started",
		"Voice Recording Stopped",
	],
	"vs/platform/action/common/actionCommonCategories": [
		"Ver",
		"Ayuda",
		"Probar",
		"archivo",
		"Preferencias",
		"Desarrollador",
	],
	"vs/platform/actionWidget/browser/actionList": [
		"{0} to Apply, {1} to Preview",
		"{0} to Apply",
		"{0}, Motivo de deshabilitación: {1}",
		"Widget de acción",
	],
	"vs/platform/actionWidget/browser/actionWidget": [
		"Color de fondo de los elementos de acción alternados en la barra de acciones.",
		"Si la lista de widgets de acción es visible",
		"Ocultar el widget de acción",
		"Seleccione la acción anterior",
		"Seleccione la siguiente acción",
		"Aceptar la acción seleccionada",
		"Vista previa de la acción seleccionada",
	],
	"vs/platform/actions/browser/menuEntryActionViewItem": [
		"{0} ({1})",
		"{0} ({1})",
		"{0}\r\n[{1}] {2}",
	],
	"vs/platform/actions/browser/toolbar": [
		"Ocultar",
		"Menú Restablecer",
	],
	"vs/platform/actions/common/menuService": [
		"Ocultar \"{0}\"",
		"Configure Keybinding",
	],
	"vs/platform/configuration/common/configurationRegistry": [
		"La configuración del lenguaje predeterminada se reemplaza",
		"Configure los valores que se invalidarán para el idioma {0}.",
		"Establecer los valores de configuración que se reemplazarán para un lenguaje.",
		"Esta configuración no admite la configuración por idioma.",
		"Establecer los valores de configuración que se reemplazarán para un lenguaje.",
		"Esta configuración no admite la configuración por idioma.",
		"No se puede registrar una propiedad vacía.",
		"No se puede registrar \"{0}\". Coincide con el patrón de propiedad \'\\\\[.*\\\\]$\' para describir la configuración del editor específica del lenguaje. Utilice la contribución \"configurationDefaults\".",
		"No se puede registrar \"{0}\". Esta propiedad ya está registrada.",
		"No se puede registrar \"{0}\". La directiva asociada {1} ya está registrada con {2}.",
	],
	"vs/platform/contextkey/browser/contextKeyService": [
		"Comando que devuelve información sobre las claves de contexto",
	],
	"vs/platform/contextkey/common/contextkey": [
		"Expresión de clave de contexto vacía",
		"¿Ha olvidado escribir una expresión? también puede poner \"false\" o \"true\" para evaluar siempre como false o true, respectivamente.",
		"\'in\' después de \'not\'.",
		"paréntesis de cierre \')\'",
		"Token inesperado",
		"¿Ha olvidado poner && o || antes del token?",
		"Final de expresión inesperado",
		"¿Ha olvidado poner una clave de contexto?",
		"Esperado: {0}\r\nrecibido: \'{1}\'.",
	],
	"vs/platform/contextkey/common/contextkeys": [
		"Si el sistema operativo es macOS",
		"Si el sistema operativo es Linux",
		"Si el sistema operativo es Windows",
		"Si la plataforma es un explorador web",
		"Si el sistema operativo es macOS en una plataforma que no es de explorador",
		"Si el sistema operativo es IOS",
		"Si la plataforma es un explorador web móvil",
		"Tipo de calidad de VS Code",
		"Si el foco del teclado está dentro de un cuadro de entrada",
	],
	"vs/platform/contextkey/common/scanner": [
		"¿Quiso decir {0}?",
		"¿Quiso decir {0} o {1}?",
		"¿Quiso decir {0}, {1} o {2}?",
		"¿Ha olvidado abrir o cerrar la cita?",
		"¿Ha olvidado escapar el carácter \"/\" (barra diagonal)?Coloque dos barras diagonales inversas antes de que escape, por ejemplo, \'\\\\/\'.",
	],
	"vs/platform/history/browser/contextScopedHistoryWidget": [
		"Indica si las sugerencias están visibles.",
	],
	"vs/platform/keybinding/common/abstractKeybindingService": [
		"Se presionó ({0}). Esperando la siguiente tecla...",
		"Se ha presionado ({0}). Esperando la siguiente tecla...",
		"La combinación de claves ({0}, {1}) no es un comando.",
		"La combinación de claves ({0}, {1}) no es un comando.",
	],
	"vs/platform/list/browser/listService": [
		"Área de trabajo",
		"Se asigna a \"Control\" en Windows y Linux y a \"Comando\" en macOS.",
		"Se asigna a \"Alt\" en Windows y Linux y a \"Opción\" en macOS.",
		"El modificador que se utilizará para agregar un elemento en los árboles y listas para una selección múltiple con el ratón (por ejemplo en el explorador, abiertos editores y vista de scm). Los gestos de ratón \'Abrir hacia\' - si están soportados - se adaptarán de forma tal que no tenga conflicto con el modificador múltiple.",
		"Controla cómo abrir elementos en los árboles y las listas mediante el mouse (si se admite). Tenga en cuenta que algunos árboles y listas pueden optar por ignorar esta configuración si no es aplicable.",
		"Controla si las listas y los árboles admiten el desplazamiento horizontal en el área de trabajo. Advertencia: La activación de esta configuración repercute en el rendimiento.",
		"Controla si los clics en la barra de desplazamiento se desplazan página por página.",
		"Controla la sangría de árbol en píxeles.",
		"Controla si el árbol debe representar guías de sangría.",
		"Controla si las listas y los árboles tienen un desplazamiento suave.",
		"Se usará un multiplicador en los eventos de desplazamiento de la rueda del mouse \"deltaX\" y \"deltaY\". ",
		"Multiplicador de la velocidad de desplazamiento al presionar \"Alt\".",
		"Resalta elementos al buscar. Navegar más arriba o abajo pasará solo por los elementos resaltados.",
		"Filtre elementos al buscar.",
		"Controla el modo de búsqueda predeterminado para listas y árboles en el área de trabajo.",
		"La navegación simple del teclado se centra en elementos que coinciden con la entrada del teclado. El emparejamiento se hace solo en prefijos.",
		"Destacar la navegación del teclado resalta los elementos que coinciden con la entrada del teclado. Más arriba y abajo la navegación atravesará solo los elementos destacados.",
		"La navegación mediante el teclado de filtro filtrará y ocultará todos los elementos que no coincidan con la entrada del teclado.",
		"Controla el estilo de navegación del teclado para listas y árboles en el área de trabajo. Puede ser simple, resaltar y filtrar.",
		"Use \"workbench.list.defaultFindMode\" y \"workbench.list.typeNavigationMode\" en su lugar.",
		"Usar coincidencias aproximadas al buscar.",
		"Use coincidencias contiguas al buscar.",
		"Controla el tipo de coincidencia que se usa al buscar listas y árboles en el área de trabajo.",
		"Controla cómo se expanden las carpetas de árbol al hacer clic en sus nombres. Tenga en cuenta que algunos árboles y listas pueden optar por omitir esta configuración si no es aplicable.",
		"Controla si el desplazamiento permanente está habilitado en los árboles.",
		"Controla el número de elementos permanentes que se muestran en el árbol cuando \'#workbench.tree.enableStickyScroll#\' está habilitado.",
		"Controla el funcionamiento de la navegación por tipos en listas y árboles del área de trabajo. Cuando se establece en \"trigger\", la navegación por tipos comienza una vez que se ejecuta el comando \"list.triggerTypeNavigation\".",
	],
	"vs/platform/markers/common/markers": [
		"Error",
		"Advertencia",
		"Información",
	],
	"vs/platform/quickinput/browser/commandsQuickAccess": [
		"usado recientemente",
		"comandos similares",
		"usados habitualmente",
		"otros comandos",
		"comandos similares",
		"{0}, {1}",
		"El comando \"{0}\" ha dado lugar a un error",
	],
	"vs/platform/quickinput/browser/helpQuickAccess": [
		"{0}, {1}",
	],
	"vs/platform/quickinput/browser/quickInput": [
		"Atrás",
		"Presione \"Entrar\" para confirmar su entrada o \"Esc\" para cancelar",
		"{0}/{1}",
		"Escriba para restringir los resultados.",
	],
	"vs/platform/quickinput/browser/quickInputController": [
		"Activar o desactivar todas las casillas",
		"{0} resultados",
		"{0} seleccionados",
		"Aceptar",
		"Personalizado",
		"Atrás ({0})",
		"Atrás",
	],
	"vs/platform/quickinput/browser/quickInputTree": [
		"Quick Input",
	],
	"vs/platform/quickinput/browser/quickInputUtils": [
		"Haga clic en para ejecutar el comando \"{0}\"",
	],
	"vs/platform/theme/common/colors/baseColors": [
		"Overall foreground color. This color is only used if not overridden by a component.",
		"Overall foreground for disabled elements. This color is only used if not overridden by a component.",
		"Overall foreground color for error messages. This color is only used if not overridden by a component.",
		"Foreground color for description text providing additional information, for example for a label.",
		"The default color for icons in the workbench.",
		"Overall border color for focused elements. This color is only used if not overridden by a component.",
		"An extra border around elements to separate them from others for greater contrast.",
		"An extra border around active elements to separate them from others for greater contrast.",
		"The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor.",
		"Foreground color for links in text.",
		"Foreground color for links in text when clicked on and on mouse hover.",
		"Color for text separators.",
		"Foreground color for preformatted text segments.",
		"Background color for preformatted text segments.",
		"Background color for block quotes in text.",
		"Border color for block quotes in text.",
		"Background color for code blocks in text.",
	],
	"vs/platform/theme/common/colors/chartsColors": [
		"The foreground color used in charts.",
		"The color used for horizontal lines in charts.",
		"The red color used in chart visualizations.",
		"The blue color used in chart visualizations.",
		"The yellow color used in chart visualizations.",
		"The orange color used in chart visualizations.",
		"The green color used in chart visualizations.",
		"The purple color used in chart visualizations.",
	],
	"vs/platform/theme/common/colors/editorColors": [
		"Editor background color.",
		"Editor default foreground color.",
		"Background color of sticky scroll in the editor",
		"Background color of sticky scroll on hover in the editor",
		"Border color of sticky scroll in the editor",
		" Shadow color of sticky scroll in the editor",
		"Background color of editor widgets, such as find/replace.",
		"Foreground color of editor widgets, such as find/replace.",
		"Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget.",
		"Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget.",
		"Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of error squigglies in the editor.",
		"If set, color of double underlines for errors in the editor.",
		"Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of warning squigglies in the editor.",
		"If set, color of double underlines for warnings in the editor.",
		"Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of info squigglies in the editor.",
		"If set, color of double underlines for infos in the editor.",
		"Foreground color of hint squigglies in the editor.",
		"If set, color of double underlines for hints in the editor.",
		"Color of active links.",
		"Color of the editor selection.",
		"Color of the selected text for high contrast.",
		"Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations.",
		"Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations.",
		"Border color for regions with the same content as the selection.",
		"Color of the current search match.",
		"Color of the other search matches. The color must not be opaque so as not to hide underlying decorations.",
		"Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations.",
		"Border color of the current search match.",
		"Border color of the other search matches.",
		"Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations.",
		"Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations.",
		"Background color of the editor hover.",
		"Foreground color of the editor hover.",
		"Border color of the editor hover.",
		"Background color of the editor hover status bar.",
		"Foreground color of inline hints",
		"Background color of inline hints",
		"Foreground color of inline hints for types",
		"Background color of inline hints for types",
		"Foreground color of inline hints for parameters",
		"Background color of inline hints for parameters",
		"The color used for the lightbulb actions icon.",
		"The color used for the lightbulb auto fix actions icon.",
		"The color used for the lightbulb AI icon.",
		"Highlight background color of a snippet tabstop.",
		"Highlight border color of a snippet tabstop.",
		"Highlight background color of the final tabstop of a snippet.",
		"Highlight border color of the final tabstop of a snippet.",
		"Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for the margin where lines got inserted.",
		"Background color for the margin where lines got removed.",
		"Diff overview ruler foreground for inserted content.",
		"Diff overview ruler foreground for removed content.",
		"Outline color for the text that got inserted.",
		"Outline color for text that got removed.",
		"Border color between the two text editors.",
		"Color of the diff editor\'s diagonal fill. The diagonal fill is used in side-by-side diff views.",
		"The background color of unchanged blocks in the diff editor.",
		"The foreground color of unchanged blocks in the diff editor.",
		"The background color of unchanged code in the diff editor.",
		"Shadow color of widgets such as find/replace inside the editor.",
		"Border color of widgets such as find/replace inside the editor.",
		"Toolbar background when hovering over actions using the mouse",
		"Toolbar outline when hovering over actions using the mouse",
		"Toolbar background when holding the mouse over actions",
		"Color of focused breadcrumb items.",
		"Background color of breadcrumb items.",
		"Color of focused breadcrumb items.",
		"Color of selected breadcrumb items.",
		"Background color of breadcrumb item picker.",
		"Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Border color on headers and the splitter in inline merge-conflicts.",
		"Current overview ruler foreground for inline merge-conflicts.",
		"Incoming overview ruler foreground for inline merge-conflicts.",
		"Common ancestor overview ruler foreground for inline merge-conflicts.",
		"Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations.",
		"Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations.",
		"The color used for the problems error icon.",
		"The color used for the problems warning icon.",
		"The color used for the problems info icon.",
	],
	"vs/platform/theme/common/colors/inputColors": [
		"Input box background.",
		"Input box foreground.",
		"Input box border.",
		"Border color of activated options in input fields.",
		"Background color of activated options in input fields.",
		"Background hover color of options in input fields.",
		"Foreground color of activated options in input fields.",
		"Input box foreground color for placeholder text.",
		"Input validation background color for information severity.",
		"Input validation foreground color for information severity.",
		"Input validation border color for information severity.",
		"Input validation background color for warning severity.",
		"Input validation foreground color for warning severity.",
		"Input validation border color for warning severity.",
		"Input validation background color for error severity.",
		"Input validation foreground color for error severity.",
		"Input validation border color for error severity.",
		"Dropdown background.",
		"Dropdown list background.",
		"Dropdown foreground.",
		"Dropdown border.",
		"Button foreground color.",
		"Button separator color.",
		"Button background color.",
		"Button background color when hovering.",
		"Button border color.",
		"Secondary button foreground color.",
		"Secondary button background color.",
		"Secondary button background color when hovering.",
		"Background color of checkbox widget.",
		"Background color of checkbox widget when the element it\'s in is selected.",
		"Foreground color of checkbox widget.",
		"Border color of checkbox widget.",
		"Border color of checkbox widget when the element it\'s in is selected.",
		"Keybinding label background color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label border color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut.",
	],
	"vs/platform/theme/common/colors/listColors": [
		"List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background when hovering over items using the mouse.",
		"List/Tree foreground when hovering over items using the mouse.",
		"List/Tree drag and drop background when moving items over other items when using the mouse.",
		"List/Tree drag and drop border color when moving items between items when using the mouse.",
		"List/Tree foreground color of the match highlights when searching inside the list/tree.",
		"List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree.",
		"List/Tree foreground color for invalid items, for example an unresolved root in explorer.",
		"Foreground color of list items containing errors.",
		"Foreground color of list items containing warnings.",
		"Background color of the type filter widget in lists and trees.",
		"Outline color of the type filter widget in lists and trees.",
		"Outline color of the type filter widget in lists and trees, when there are no matches.",
		"Shadow color of the type filter widget in lists and trees.",
		"Background color of the filtered match.",
		"Border color of the filtered match.",
		"List/Tree foreground color for items that are deemphasized.",
		"Tree stroke color for the indentation guides.",
		"Tree stroke color for the indentation guides that are not active.",
		"Table border color between columns.",
		"Background color for odd table rows.",
	],
	"vs/platform/theme/common/colors/menuColors": [
		"Border color of menus.",
		"Foreground color of menu items.",
		"Background color of menu items.",
		"Foreground color of the selected menu item in menus.",
		"Background color of the selected menu item in menus.",
		"Border color of the selected menu item in menus.",
		"Color of a separator menu item in menus.",
	],
	"vs/platform/theme/common/colors/minimapColors": [
		"Minimap marker color for find matches.",
		"Minimap marker color for repeating editor selections.",
		"Minimap marker color for the editor selection.",
		"Minimap marker color for infos.",
		"Minimap marker color for warnings.",
		"Minimap marker color for errors.",
		"Minimap background color.",
		"Opacity of foreground elements rendered in the minimap. For example, \"#000000c0\" will render the elements with 75% opacity.",
		"Minimap slider background color.",
		"Minimap slider background color when hovering.",
		"Minimap slider background color when clicked on.",
	],
	"vs/platform/theme/common/colors/miscColors": [
		"Border color of active sashes.",
		"Badge background color. Badges are small information labels, e.g. for search results count.",
		"Badge foreground color. Badges are small information labels, e.g. for search results count.",
		"Scrollbar shadow to indicate that the view is scrolled.",
		"Scrollbar slider background color.",
		"Scrollbar slider background color when hovering.",
		"Scrollbar slider background color when clicked on.",
		"Background color of the progress bar that can show for long running operations.",
	],
	"vs/platform/theme/common/colors/quickpickColors": [
		"Quick picker background color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker foreground color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker title background color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker color for grouping labels.",
		"Quick picker color for grouping borders.",
		"Please use quickInputList.focusBackground instead",
		"Quick picker foreground color for the focused item.",
		"Quick picker icon foreground color for the focused item.",
		"Quick picker background color for the focused item.",
	],
	"vs/platform/theme/common/colors/searchColors": [
		"Color of the text in the search viewlet\'s completion message.",
		"Color of the Search Editor query matches.",
		"Border color of the Search Editor query matches.",
	],
	"vs/platform/theme/common/iconRegistry": [
		"Identificador de la fuente que se va a usar. Si no se establece, se usa la fuente definida en primer lugar.",
		"Carácter de fuente asociado a la definición del icono.",
		"Icono de la acción de cierre en los widgets.",
		"Icono para ir a la ubicación del editor anterior.",
		"Icono para ir a la ubicación del editor siguiente.",
	],
	"vs/platform/undoRedo/common/undoRedoService": [
		"Se han cerrado los siguientes archivos y se han modificado en el disco: {0}.",
		"Los siguientes archivos se han modificado de forma incompatible: {0}.",
		"No se pudo deshacer \"{0}\" en todos los archivos. {1}",
		"No se pudo deshacer \"{0}\" en todos los archivos. {1}",
		"No se pudo deshacer \"{0}\" en todos los archivos porque se realizaron cambios en {1}",
		"No se pudo deshacer \"{0}\" en todos los archivos porque ya hay una operación de deshacer o rehacer en ejecución en {1}",
		"No se pudo deshacer \"{0}\" en todos los archivos porque se produjo una operación de deshacer o rehacer mientras tanto",
		"¿Desea deshacer \"{0}\" en todos los archivos?",
		"&&Deshacer en {0} archivos",
		"Deshacer este &&archivo",
		"No se pudo deshacer \"{0}\" porque ya hay una operación de deshacer o rehacer en ejecución.",
		"¿Quiere deshacer \"{0}\"?",
		"&&Sí",
		"No",
		"No se pudo rehacer \"{0}\" en todos los archivos. {1}",
		"No se pudo rehacer \"{0}\" en todos los archivos. {1}",
		"No se pudo volver a hacer \"{0}\" en todos los archivos porque se realizaron cambios en {1}",
		"No se pudo rehacer \"{0}\" en todos los archivos porque ya hay una operación de deshacer o rehacer en ejecución en {1}",
		"No se pudo rehacer \"{0}\" en todos los archivos porque se produjo una operación de deshacer o rehacer mientras tanto",
		"No se pudo rehacer \"{0}\" porque ya hay una operación de deshacer o rehacer en ejecución.",
	],
	"vs/platform/workspace/common/workspace": [
		"Área de trabajo de código",
	]
});